var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceicon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 81,
    viewBox: "0 0 75 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.43441 63.7114C4.97218 59.5219 2.06392 54.8669 0.725192 49.6067C-0.798186 43.5552 -0.013416 36.6658 3.9566 31.8712C9.44999 25.2611 19.0519 24.1905 26.4841 19.9544C34.7473 15.2529 40.9793 6.22218 50.3504 4.77913C61.5218 3.05678 71.5854 13.6236 73.6165 24.8422C78.1405 49.6998 59.6291 87.8242 29.854 79.166C22.0986 76.9316 15.4512 71.6249 10.0501 65.5734C9.49616 64.9682 8.98836 64.3631 8.43441 63.7114Z",
    fill: "#C9ACFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5337 33.1113C19.4881 33.2487 19.397 33.386 19.2148 33.386C19.1236 33.386 18.987 33.3402 18.9414 33.2487C19.1237 33.2029 19.3515 33.1571 19.5337 33.1113Z",
    fill: "url(#paint0_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 33.067C22.0851 33.2502 21.9484 33.3875 21.7662 33.3875C21.5839 33.3875 21.4473 33.2502 21.4473 33.067C21.4473 33.0213 21.4473 32.9755 21.4928 32.9297C21.5839 32.9297 21.7206 32.9297 21.8118 32.9297C21.9029 32.9297 21.994 32.9297 22.0851 32.9297C22.0396 32.9755 22.0851 33.0213 22.0851 33.067Z",
    fill: "url(#paint1_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.5454 33.2487C24.4999 33.3402 24.4087 33.386 24.272 33.386C24.1354 33.386 23.9987 33.2487 23.9531 33.1113C24.1354 33.1571 24.3632 33.2029 24.5454 33.2487Z",
    fill: "url(#paint2_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 34.6252C17.0265 34.8083 16.8898 34.9456 16.7076 34.9456C16.5254 34.9456 16.3887 34.8083 16.3887 34.6252C16.3887 34.442 16.5254 34.3047 16.7076 34.3047C16.8898 34.3047 17.0265 34.442 17.0265 34.6252Z",
    fill: "url(#paint3_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 34.6252C19.5343 34.8083 19.3977 34.9456 19.2154 34.9456C19.0332 34.9456 18.8965 34.8083 18.8965 34.6252C18.8965 34.442 19.0332 34.3047 19.2154 34.3047C19.3977 34.3047 19.5343 34.442 19.5343 34.6252Z",
    fill: "url(#paint4_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 34.6252C22.0851 34.8083 21.9484 34.9456 21.7662 34.9456C21.5839 34.9456 21.4473 34.8083 21.4473 34.6252C21.4473 34.442 21.5839 34.3047 21.7662 34.3047C21.9029 34.3047 22.0851 34.442 22.0851 34.6252Z",
    fill: "url(#paint5_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 34.6252C24.591 34.8083 24.4543 34.9456 24.272 34.9456C24.0898 34.9456 23.9531 34.8083 23.9531 34.6252C23.9531 34.442 24.0898 34.3047 24.272 34.3047C24.4543 34.3047 24.591 34.442 24.591 34.6252Z",
    fill: "url(#paint6_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 34.6252C27.0968 34.8083 26.9602 34.9456 26.7779 34.9456C26.5957 34.9456 26.459 34.8083 26.459 34.6252C26.459 34.442 26.5957 34.3047 26.7779 34.3047C26.9602 34.3047 27.0968 34.442 27.0968 34.6252Z",
    fill: "url(#paint7_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 36.3185C14.4777 36.5017 14.341 36.639 14.1588 36.639C13.9765 36.639 13.8398 36.5017 13.8398 36.3185C13.8398 36.1354 13.9765 35.998 14.1588 35.998C14.341 35.998 14.4777 36.1812 14.4777 36.3185Z",
    fill: "url(#paint8_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 36.639C16.8837 36.639 17.0265 36.4955 17.0265 36.3185C17.0265 36.1415 16.8837 35.998 16.7076 35.998C16.5315 35.998 16.3887 36.1415 16.3887 36.3185C16.3887 36.4955 16.5315 36.639 16.7076 36.639Z",
    fill: "url(#paint9_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 36.3185C19.5343 36.5017 19.3977 36.639 19.2154 36.639C19.0332 36.639 18.8965 36.5017 18.8965 36.3185C18.8965 36.1354 19.0332 35.998 19.2154 35.998C19.3977 35.998 19.5343 36.1812 19.5343 36.3185Z",
    fill: "url(#paint10_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 36.639C21.8955 36.639 22.0382 36.4955 22.0382 36.3185C22.0382 36.1415 21.8955 35.998 21.7193 35.998C21.5432 35.998 21.4004 36.1415 21.4004 36.3185C21.4004 36.4955 21.5432 36.639 21.7193 36.639Z",
    fill: "url(#paint11_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 36.3185C24.591 36.5017 24.4543 36.639 24.272 36.639C24.0898 36.639 23.9531 36.5017 23.9531 36.3185C23.9531 36.1354 24.0898 35.998 24.272 35.998C24.4543 35.998 24.591 36.1812 24.591 36.3185Z",
    fill: "url(#paint12_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.7779 36.639C26.954 36.639 27.0968 36.4955 27.0968 36.3185C27.0968 36.1415 26.954 35.998 26.7779 35.998C26.6018 35.998 26.459 36.1415 26.459 36.3185C26.459 36.4955 26.6018 36.639 26.7779 36.639Z",
    fill: "url(#paint13_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 36.3185C29.6476 36.5017 29.5109 36.639 29.3287 36.639C29.1464 36.639 29.0098 36.5017 29.0098 36.3185C29.0098 36.1354 29.1464 35.998 29.3287 35.998C29.4654 35.998 29.6476 36.1812 29.6476 36.3185Z",
    fill: "url(#paint14_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9706 38.0579C11.9706 38.241 11.8339 38.3784 11.6516 38.3784C11.5605 38.3784 11.4694 38.3326 11.4238 38.2868C11.5605 38.1037 11.6972 37.9663 11.7883 37.7832C11.925 37.7832 11.9706 37.9206 11.9706 38.0579Z",
    fill: "url(#paint15_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 38.0588C14.4777 38.2419 14.341 38.3792 14.1588 38.3792C13.9765 38.3792 13.8398 38.2419 13.8398 38.0588C13.8398 37.8756 13.9765 37.7383 14.1588 37.7383C14.341 37.7383 14.4777 37.8756 14.4777 38.0588Z",
    fill: "url(#paint16_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 38.3792C16.8837 38.3792 17.0265 38.2358 17.0265 38.0588C17.0265 37.8818 16.8837 37.7383 16.7076 37.7383C16.5315 37.7383 16.3887 37.8818 16.3887 38.0588C16.3887 38.2358 16.5315 38.3792 16.7076 38.3792Z",
    fill: "url(#paint17_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 38.0588C19.5343 38.2419 19.3977 38.3792 19.2154 38.3792C19.0332 38.3792 18.8965 38.2419 18.8965 38.0588C18.8965 37.8756 19.0332 37.7383 19.2154 37.7383C19.3977 37.7383 19.5343 37.8756 19.5343 38.0588Z",
    fill: "url(#paint18_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 38.3792C21.8955 38.3792 22.0382 38.2358 22.0382 38.0588C22.0382 37.8818 21.8955 37.7383 21.7193 37.7383C21.5432 37.7383 21.4004 37.8818 21.4004 38.0588C21.4004 38.2358 21.5432 38.3792 21.7193 38.3792Z",
    fill: "url(#paint19_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 38.0588C24.591 38.2419 24.4543 38.3792 24.272 38.3792C24.0898 38.3792 23.9531 38.2419 23.9531 38.0588C23.9531 37.8756 24.0898 37.7383 24.272 37.7383C24.4543 37.7383 24.591 37.8756 24.591 38.0588Z",
    fill: "url(#paint20_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.7779 38.3792C26.954 38.3792 27.0968 38.2358 27.0968 38.0588C27.0968 37.8818 26.954 37.7383 26.7779 37.7383C26.6018 37.7383 26.459 37.8818 26.459 38.0588C26.459 38.2358 26.6018 38.3792 26.7779 38.3792Z",
    fill: "url(#paint21_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 38.0588C29.6476 38.2419 29.5109 38.3792 29.3287 38.3792C29.1464 38.3792 29.0098 38.2419 29.0098 38.0588C29.0098 37.8756 29.1464 37.7383 29.3287 37.7383C29.4654 37.7383 29.6476 37.8756 29.6476 38.0588Z",
    fill: "url(#paint22_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1079 38.195C32.0624 38.2866 31.9712 38.3324 31.8346 38.3324C31.6523 38.3324 31.5156 38.195 31.5156 38.0119C31.5156 37.8745 31.6067 37.7372 31.7434 37.6914C31.8801 37.8745 31.9712 38.0577 32.1079 38.195Z",
    fill: "url(#paint23_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 39.7521C11.9699 39.9352 11.8332 40.0726 11.651 40.0726C11.4687 40.0726 11.332 39.9352 11.332 39.7521C11.332 39.569 11.4687 39.4316 11.651 39.4316C11.8332 39.4316 11.9699 39.569 11.9699 39.7521Z",
    fill: "url(#paint24_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 39.7521C14.4777 39.9352 14.341 40.0726 14.1588 40.0726C13.9765 40.0726 13.8398 39.9352 13.8398 39.7521C13.8398 39.569 13.9765 39.4316 14.1588 39.4316C14.341 39.4316 14.4777 39.569 14.4777 39.7521Z",
    fill: "url(#paint25_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 39.7521C17.0265 39.9352 16.8898 40.0726 16.7076 40.0726C16.5254 40.0726 16.3887 39.9352 16.3887 39.7521C16.3887 39.569 16.5254 39.4316 16.7076 39.4316C16.8898 39.4316 17.0265 39.569 17.0265 39.7521Z",
    fill: "url(#paint26_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 39.7521C19.5343 39.9352 19.3977 40.0726 19.2154 40.0726C19.0332 40.0726 18.8965 39.9352 18.8965 39.7521C18.8965 39.569 19.0332 39.4316 19.2154 39.4316C19.3977 39.4316 19.5343 39.569 19.5343 39.7521Z",
    fill: "url(#paint27_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 39.7521C22.0851 39.9352 21.9484 40.0726 21.7662 40.0726C21.5839 40.0726 21.4473 39.9352 21.4473 39.7521C21.4473 39.569 21.5839 39.4316 21.7662 39.4316C21.9029 39.4316 22.0851 39.569 22.0851 39.7521Z",
    fill: "url(#paint28_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 39.7521C24.591 39.9352 24.4543 40.0726 24.272 40.0726C24.0898 40.0726 23.9531 39.9352 23.9531 39.7521C23.9531 39.569 24.0898 39.4316 24.272 39.4316C24.4543 39.4316 24.591 39.569 24.591 39.7521Z",
    fill: "url(#paint29_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 39.7521C27.0968 39.9352 26.9602 40.0726 26.7779 40.0726C26.5957 40.0726 26.459 39.9352 26.459 39.7521C26.459 39.569 26.5957 39.4316 26.7779 39.4316C26.9602 39.4316 27.0968 39.569 27.0968 39.7521Z",
    fill: "url(#paint30_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 39.7521C29.6476 39.9352 29.5109 40.0726 29.3287 40.0726C29.1464 40.0726 29.0098 39.9352 29.0098 39.7521C29.0098 39.569 29.1464 39.4316 29.3287 39.4316C29.4654 39.4316 29.6476 39.569 29.6476 39.7521Z",
    fill: "url(#paint31_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1535 39.7521C32.1535 39.9352 32.0168 40.0726 31.8346 40.0726C31.6523 40.0726 31.5156 39.9352 31.5156 39.7521C31.5156 39.569 31.6523 39.4316 31.8346 39.4316C32.0168 39.4316 32.1535 39.569 32.1535 39.7521Z",
    fill: "url(#paint32_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 41.4455C11.9699 41.6286 11.8332 41.766 11.651 41.766C11.4687 41.766 11.332 41.6286 11.332 41.4455C11.332 41.2623 11.4687 41.125 11.651 41.125C11.8332 41.125 11.9699 41.2623 11.9699 41.4455Z",
    fill: "url(#paint33_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 41.4455C14.4777 41.6286 14.341 41.766 14.1588 41.766C13.9765 41.766 13.8398 41.6286 13.8398 41.4455C13.8398 41.2623 13.9765 41.125 14.1588 41.125C14.341 41.125 14.4777 41.2623 14.4777 41.4455Z",
    fill: "url(#paint34_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 41.4455C17.0265 41.6286 16.8898 41.766 16.7076 41.766C16.5254 41.766 16.3887 41.6286 16.3887 41.4455C16.3887 41.2623 16.5254 41.125 16.7076 41.125C16.8898 41.125 17.0265 41.2623 17.0265 41.4455Z",
    fill: "url(#paint35_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 41.4455C19.5343 41.6286 19.3977 41.766 19.2154 41.766C19.0332 41.766 18.8965 41.6286 18.8965 41.4455C18.8965 41.2623 19.0332 41.125 19.2154 41.125C19.3977 41.125 19.5343 41.2623 19.5343 41.4455Z",
    fill: "url(#paint36_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 41.4455C22.0851 41.6286 21.9484 41.766 21.7662 41.766C21.5839 41.766 21.4473 41.6286 21.4473 41.4455C21.4473 41.2623 21.5839 41.125 21.7662 41.125C21.9029 41.125 22.0851 41.2623 22.0851 41.4455Z",
    fill: "url(#paint37_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 41.4455C24.591 41.6286 24.4543 41.766 24.272 41.766C24.0898 41.766 23.9531 41.6286 23.9531 41.4455C23.9531 41.2623 24.0898 41.125 24.272 41.125C24.4543 41.125 24.591 41.2623 24.591 41.4455Z",
    fill: "url(#paint38_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 41.4455C27.0968 41.6286 26.9602 41.766 26.7779 41.766C26.5957 41.766 26.459 41.6286 26.459 41.4455C26.459 41.2623 26.5957 41.125 26.7779 41.125C26.9602 41.125 27.0968 41.2623 27.0968 41.4455Z",
    fill: "url(#paint39_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 41.4455C29.6476 41.6286 29.5109 41.766 29.3287 41.766C29.1464 41.766 29.0098 41.6286 29.0098 41.4455C29.0098 41.2623 29.1464 41.125 29.3287 41.125C29.4654 41.125 29.6476 41.2623 29.6476 41.4455Z",
    fill: "url(#paint40_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1535 41.4455C32.1535 41.6286 32.0168 41.766 31.8346 41.766C31.6523 41.766 31.5156 41.6286 31.5156 41.4455C31.5156 41.2623 31.6523 41.125 31.8346 41.125C32.0168 41.125 32.1535 41.2623 32.1535 41.4455Z",
    fill: "url(#paint41_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60085 43.141C9.60085 43.2784 9.50973 43.4157 9.37305 43.4615C9.41861 43.2784 9.46417 43.0952 9.50973 42.9121C9.55529 42.9579 9.60085 43.0495 9.60085 43.141Z",
    fill: "url(#paint42_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 43.1427C11.9699 43.3259 11.8332 43.4632 11.651 43.4632C11.4687 43.4632 11.332 43.3259 11.332 43.1427C11.332 42.9596 11.4687 42.8223 11.651 42.8223C11.8332 42.8223 11.9699 42.9596 11.9699 43.1427Z",
    fill: "url(#paint43_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 43.1427C14.4777 43.3259 14.341 43.4632 14.1588 43.4632C13.9765 43.4632 13.8398 43.3259 13.8398 43.1427C13.8398 42.9596 13.9765 42.8223 14.1588 42.8223C14.341 42.8223 14.4777 42.9596 14.4777 43.1427Z",
    fill: "url(#paint44_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 43.4632C16.8837 43.4632 17.0265 43.3197 17.0265 43.1427C17.0265 42.9657 16.8837 42.8223 16.7076 42.8223C16.5315 42.8223 16.3887 42.9657 16.3887 43.1427C16.3887 43.3197 16.5315 43.4632 16.7076 43.4632Z",
    fill: "url(#paint45_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 43.1427C19.5343 43.3259 19.3977 43.4632 19.2154 43.4632C19.0332 43.4632 18.8965 43.3259 18.8965 43.1427C18.8965 42.9596 19.0332 42.8223 19.2154 42.8223C19.3977 42.8223 19.5343 42.9596 19.5343 43.1427Z",
    fill: "url(#paint46_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 43.4632C21.8955 43.4632 22.0382 43.3197 22.0382 43.1427C22.0382 42.9657 21.8955 42.8223 21.7193 42.8223C21.5432 42.8223 21.4004 42.9657 21.4004 43.1427C21.4004 43.3197 21.5432 43.4632 21.7193 43.4632Z",
    fill: "url(#paint47_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 43.1427C24.591 43.3259 24.4543 43.4632 24.272 43.4632C24.0898 43.4632 23.9531 43.3259 23.9531 43.1427C23.9531 42.9596 24.0898 42.8223 24.272 42.8223C24.4543 42.8223 24.591 42.9596 24.591 43.1427Z",
    fill: "url(#paint48_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.778 43.4635C26.9542 43.4635 27.097 43.32 27.097 43.143C27.097 42.966 26.9542 42.8225 26.778 42.8225C26.6019 42.8225 26.4591 42.966 26.4591 43.143C26.4591 43.32 26.6019 43.4635 26.778 43.4635Z",
    fill: "url(#paint49_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 43.1427C29.6476 43.3259 29.5109 43.4632 29.3287 43.4632C29.1464 43.4632 29.0098 43.3259 29.0098 43.1427C29.0098 42.9596 29.1464 42.8223 29.3287 42.8223C29.4654 42.8223 29.6476 42.9596 29.6476 43.1427Z",
    fill: "url(#paint50_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 43.143C32.1534 43.3261 32.0167 43.4635 31.8344 43.4635C31.6522 43.4635 31.5155 43.3261 31.5155 43.143C31.5155 42.9599 31.6522 42.8225 31.8344 42.8225C32.0167 42.8225 32.1534 42.9599 32.1534 43.143Z",
    fill: "url(#paint51_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M34.0689 43.4585C33.8867 43.4585 33.75 43.3211 33.75 43.138C33.75 43.0006 33.8411 42.9091 33.9322 42.8633C34.0234 43.0464 34.0689 43.2753 34.0689 43.4585Z",
    fill: "url(#paint52_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60146 44.8786C9.60146 45.0618 9.46477 45.1991 9.28253 45.1991C9.23697 45.1991 9.23697 45.1991 9.19141 45.1991C9.19141 44.9702 9.23697 44.7871 9.23697 44.5581H9.28253C9.46477 44.5124 9.60146 44.6955 9.60146 44.8786Z",
    fill: "url(#paint53_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 44.8784C11.9699 45.0615 11.8332 45.1989 11.651 45.1989C11.4687 45.1989 11.332 45.0615 11.332 44.8784C11.332 44.6952 11.4687 44.5579 11.651 44.5579C11.8332 44.5121 11.9699 44.6952 11.9699 44.8784Z",
    fill: "url(#paint54_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 44.8784C14.4777 45.0615 14.341 45.1989 14.1588 45.1989C13.9765 45.1989 13.8398 45.0615 13.8398 44.8784C13.8398 44.6952 13.9765 44.5579 14.1588 44.5579C14.341 44.5121 14.4777 44.6952 14.4777 44.8784Z",
    fill: "url(#paint55_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 44.8784C17.0265 45.0615 16.8898 45.1989 16.7076 45.1989C16.5254 45.1989 16.3887 45.0615 16.3887 44.8784C16.3887 44.6952 16.5254 44.5579 16.7076 44.5579C16.8898 44.5121 17.0265 44.6952 17.0265 44.8784Z",
    fill: "url(#paint56_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 44.8784C19.5343 45.0615 19.3977 45.1989 19.2154 45.1989C19.0332 45.1989 18.8965 45.0615 18.8965 44.8784C18.8965 44.6952 19.0332 44.5579 19.2154 44.5579C19.3977 44.5121 19.5343 44.6952 19.5343 44.8784Z",
    fill: "url(#paint57_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 44.8786C22.0851 45.0618 21.9484 45.1991 21.7662 45.1991C21.5839 45.1991 21.4473 45.0618 21.4473 44.8786C21.4473 44.6955 21.5839 44.5581 21.7662 44.5581C21.9029 44.5124 22.0851 44.6955 22.0851 44.8786Z",
    fill: "url(#paint58_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 44.8784C24.591 45.0615 24.4543 45.1989 24.272 45.1989C24.0898 45.1989 23.9531 45.0615 23.9531 44.8784C23.9531 44.6952 24.0898 44.5579 24.272 44.5579C24.4543 44.5121 24.591 44.6952 24.591 44.8784Z",
    fill: "url(#paint59_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.097 44.8786C27.097 45.0618 26.9603 45.1991 26.778 45.1991C26.5958 45.1991 26.4591 45.0618 26.4591 44.8786C26.4591 44.6955 26.5958 44.5581 26.778 44.5581C26.9603 44.5124 27.097 44.6955 27.097 44.8786Z",
    fill: "url(#paint60_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 44.8784C29.6476 45.0615 29.5109 45.1989 29.3287 45.1989C29.1464 45.1989 29.0098 45.0615 29.0098 44.8784C29.0098 44.6952 29.1464 44.5579 29.3287 44.5579C29.4654 44.5121 29.6476 44.6952 29.6476 44.8784Z",
    fill: "url(#paint61_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 44.8786C32.1534 45.0618 32.0167 45.1991 31.8344 45.1991C31.6522 45.1991 31.5155 45.0618 31.5155 44.8786C31.5155 44.6955 31.6522 44.5581 31.8344 44.5581C32.0167 44.5124 32.1534 44.6955 32.1534 44.8786Z",
    fill: "url(#paint62_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M34.2961 45.1069C34.2505 45.1527 34.205 45.1527 34.1139 45.1527C33.9316 45.1527 33.7949 45.0153 33.7949 44.8322C33.7949 44.6491 33.9316 44.5117 34.1139 44.5117C34.1594 44.5117 34.205 44.5117 34.2505 44.5575C34.2505 44.7406 34.2505 44.9238 34.2961 45.1069Z",
    fill: "url(#paint63_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60146 46.5744C9.60146 46.7575 9.46477 46.8949 9.28253 46.8949H9.23697C9.23697 46.6659 9.19141 46.4828 9.19141 46.2539C9.23697 46.2539 9.23697 46.2539 9.28253 46.2539C9.46477 46.2539 9.60146 46.3913 9.60146 46.5744Z",
    fill: "url(#paint64_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 46.5744C11.9699 46.7575 11.8332 46.8949 11.651 46.8949C11.4687 46.8949 11.332 46.7575 11.332 46.5744C11.332 46.3913 11.4687 46.2539 11.651 46.2539C11.8332 46.2539 11.9699 46.3913 11.9699 46.5744Z",
    fill: "url(#paint65_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 46.5744C14.4777 46.7575 14.341 46.8949 14.1588 46.8949C13.9765 46.8949 13.8398 46.7575 13.8398 46.5744C13.8398 46.3913 13.9765 46.2539 14.1588 46.2539C14.341 46.2539 14.4777 46.3913 14.4777 46.5744Z",
    fill: "url(#paint66_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 46.8949C16.8837 46.8949 17.0265 46.7514 17.0265 46.5744C17.0265 46.3974 16.8837 46.2539 16.7076 46.2539C16.5315 46.2539 16.3887 46.3974 16.3887 46.5744C16.3887 46.7514 16.5315 46.8949 16.7076 46.8949Z",
    fill: "url(#paint67_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 46.5744C19.5343 46.7575 19.3977 46.8949 19.2154 46.8949C19.0332 46.8949 18.8965 46.7575 18.8965 46.5744C18.8965 46.3913 19.0332 46.2539 19.2154 46.2539C19.3977 46.2539 19.5343 46.3913 19.5343 46.5744Z",
    fill: "url(#paint68_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 46.8949C21.8955 46.8949 22.0382 46.7514 22.0382 46.5744C22.0382 46.3974 21.8955 46.2539 21.7193 46.2539C21.5432 46.2539 21.4004 46.3974 21.4004 46.5744C21.4004 46.7514 21.5432 46.8949 21.7193 46.8949Z",
    fill: "url(#paint69_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 46.5744C24.591 46.7575 24.4543 46.8949 24.272 46.8949C24.0898 46.8949 23.9531 46.7575 23.9531 46.5744C23.9531 46.3913 24.0898 46.2539 24.272 46.2539C24.4543 46.2539 24.591 46.3913 24.591 46.5744Z",
    fill: "url(#paint70_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.778 46.8949C26.9542 46.8949 27.097 46.7514 27.097 46.5744C27.097 46.3974 26.9542 46.2539 26.778 46.2539C26.6019 46.2539 26.4591 46.3974 26.4591 46.5744C26.4591 46.7514 26.6019 46.8949 26.778 46.8949Z",
    fill: "url(#paint71_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 46.5744C29.6476 46.7575 29.5109 46.8949 29.3287 46.8949C29.1464 46.8949 29.0098 46.7575 29.0098 46.5744C29.0098 46.3913 29.1464 46.2539 29.3287 46.2539C29.4654 46.2539 29.6476 46.3913 29.6476 46.5744Z",
    fill: "url(#paint72_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 46.5744C32.1534 46.7575 32.0167 46.8949 31.8344 46.8949C31.6522 46.8949 31.5155 46.7575 31.5155 46.5744C31.5155 46.3913 31.6522 46.2539 31.8344 46.2539C32.0167 46.2539 32.1534 46.3913 32.1534 46.5744Z",
    fill: "url(#paint73_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M34.2961 46.2997C34.2961 46.4828 34.2961 46.6659 34.2505 46.8491C34.205 46.8491 34.1594 46.8949 34.1139 46.8949C33.9316 46.8949 33.7949 46.7575 33.7949 46.5744C33.7949 46.3913 33.9316 46.2539 34.1139 46.2539C34.1594 46.2539 34.2505 46.2539 34.2961 46.2997Z",
    fill: "url(#paint74_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60149 48.2669C9.60149 48.3584 9.55593 48.45 9.46481 48.5416C9.41925 48.3584 9.37369 48.1753 9.32812 47.9922C9.46481 47.9922 9.60149 48.1295 9.60149 48.2669Z",
    fill: "url(#paint75_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 48.2677C11.9699 48.4509 11.8332 48.5882 11.651 48.5882C11.4687 48.5882 11.332 48.4509 11.332 48.2677C11.332 48.0846 11.4687 47.9473 11.651 47.9473C11.8332 47.9473 11.9699 48.0846 11.9699 48.2677Z",
    fill: "url(#paint76_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 48.2677C14.4777 48.4509 14.341 48.5882 14.1588 48.5882C13.9765 48.5882 13.8398 48.4509 13.8398 48.2677C13.8398 48.0846 13.9765 47.9473 14.1588 47.9473C14.341 47.9473 14.4777 48.0846 14.4777 48.2677Z",
    fill: "url(#paint77_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 48.2677C17.0265 48.4509 16.8898 48.5882 16.7076 48.5882C16.5254 48.5882 16.3887 48.4509 16.3887 48.2677C16.3887 48.0846 16.5254 47.9473 16.7076 47.9473C16.8898 47.9473 17.0265 48.0846 17.0265 48.2677Z",
    fill: "url(#paint78_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 48.2677C19.5343 48.4509 19.3977 48.5882 19.2154 48.5882C19.0332 48.5882 18.8965 48.4509 18.8965 48.2677C18.8965 48.0846 19.0332 47.9473 19.2154 47.9473C19.3977 47.9473 19.5343 48.0846 19.5343 48.2677Z",
    fill: "url(#paint79_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 48.268C22.0851 48.4511 21.9484 48.5885 21.7662 48.5885C21.5839 48.5885 21.4473 48.4511 21.4473 48.268C21.4473 48.0849 21.5839 47.9475 21.7662 47.9475C21.9029 47.9475 22.0851 48.0849 22.0851 48.268Z",
    fill: "url(#paint80_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 48.2677C24.591 48.4509 24.4543 48.5882 24.272 48.5882C24.0898 48.5882 23.9531 48.4509 23.9531 48.2677C23.9531 48.0846 24.0898 47.9473 24.272 47.9473C24.4543 47.9473 24.591 48.0846 24.591 48.2677Z",
    fill: "url(#paint81_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.097 48.268C27.097 48.4511 26.9603 48.5885 26.778 48.5885C26.5958 48.5885 26.4591 48.4511 26.4591 48.268C26.4591 48.0849 26.5958 47.9475 26.778 47.9475C26.9603 47.9475 27.097 48.0849 27.097 48.268Z",
    fill: "url(#paint82_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 48.2677C29.6476 48.4509 29.5109 48.5882 29.3287 48.5882C29.1464 48.5882 29.0098 48.4509 29.0098 48.2677C29.0098 48.0846 29.1464 47.9473 29.3287 47.9473C29.4654 47.9473 29.6476 48.0846 29.6476 48.2677Z",
    fill: "url(#paint83_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 48.268C32.1534 48.4511 32.0167 48.5885 31.8344 48.5885C31.6522 48.5885 31.5155 48.4511 31.5155 48.268C31.5155 48.0849 31.6522 47.9475 31.8344 47.9475C32.0167 47.9475 32.1534 48.0849 32.1534 48.268Z",
    fill: "url(#paint84_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M34.1138 47.9473C34.0683 48.1762 34.0227 48.3593 33.9772 48.5882C33.8405 48.5424 33.7949 48.4051 33.7949 48.2677C33.7949 48.0846 33.9316 47.9473 34.1138 47.9473Z",
    fill: "url(#paint85_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 49.9611C11.9699 50.1442 11.8332 50.2816 11.651 50.2816C11.4687 50.2816 11.332 50.1442 11.332 49.9611C11.332 49.778 11.4687 49.6406 11.651 49.6406C11.8332 49.6406 11.9699 49.778 11.9699 49.9611Z",
    fill: "url(#paint86_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 49.9611C14.4777 50.1442 14.341 50.2816 14.1588 50.2816C13.9765 50.2816 13.8398 50.1442 13.8398 49.9611C13.8398 49.778 13.9765 49.6406 14.1588 49.6406C14.341 49.6406 14.4777 49.778 14.4777 49.9611Z",
    fill: "url(#paint87_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 49.9611C17.0265 50.1442 16.8898 50.2816 16.7076 50.2816C16.5254 50.2816 16.3887 50.1442 16.3887 49.9611C16.3887 49.778 16.5254 49.6406 16.7076 49.6406C16.8898 49.6406 17.0265 49.778 17.0265 49.9611Z",
    fill: "url(#paint88_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 49.9611C19.5343 50.1442 19.3977 50.2816 19.2154 50.2816C19.0332 50.2816 18.8965 50.1442 18.8965 49.9611C18.8965 49.778 19.0332 49.6406 19.2154 49.6406C19.3977 49.6406 19.5343 49.778 19.5343 49.9611Z",
    fill: "url(#paint89_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 49.9614C22.0851 50.1445 21.9484 50.2818 21.7662 50.2818C21.5839 50.2818 21.4473 50.1445 21.4473 49.9614C21.4473 49.7782 21.5839 49.6409 21.7662 49.6409C21.9029 49.6409 22.0851 49.7782 22.0851 49.9614Z",
    fill: "url(#paint90_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 49.9611C24.591 50.1442 24.4543 50.2816 24.272 50.2816C24.0898 50.2816 23.9531 50.1442 23.9531 49.9611C23.9531 49.778 24.0898 49.6406 24.272 49.6406C24.4543 49.6406 24.591 49.778 24.591 49.9611Z",
    fill: "url(#paint91_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.097 49.9614C27.097 50.1445 26.9603 50.2818 26.778 50.2818C26.5958 50.2818 26.4591 50.1445 26.4591 49.9614C26.4591 49.7782 26.5958 49.6409 26.778 49.6409C26.9603 49.6409 27.097 49.7782 27.097 49.9614Z",
    fill: "url(#paint92_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 49.9611C29.6476 50.1442 29.5109 50.2816 29.3287 50.2816C29.1464 50.2816 29.0098 50.1442 29.0098 49.9611C29.0098 49.778 29.1464 49.6406 29.3287 49.6406C29.4654 49.6406 29.6476 49.778 29.6476 49.9611Z",
    fill: "url(#paint93_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 49.9614C32.1534 50.1445 32.0167 50.2818 31.8344 50.2818C31.6522 50.2818 31.5155 50.1445 31.5155 49.9614C31.5155 49.7782 31.6522 49.6409 31.8344 49.6409C32.0167 49.6409 32.1534 49.7782 32.1534 49.9614Z",
    fill: "url(#paint94_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 51.6545C11.9699 51.8376 11.8332 51.9749 11.651 51.9749C11.4687 51.9749 11.332 51.8376 11.332 51.6545C11.332 51.4713 11.4687 51.334 11.651 51.334C11.8332 51.334 11.9699 51.5171 11.9699 51.6545Z",
    fill: "url(#paint95_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 51.6545C14.4777 51.8376 14.341 51.9749 14.1588 51.9749C13.9765 51.9749 13.8398 51.8376 13.8398 51.6545C13.8398 51.4713 13.9765 51.334 14.1588 51.334C14.341 51.334 14.4777 51.5171 14.4777 51.6545Z",
    fill: "url(#paint96_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 51.6545C17.0265 51.8376 16.8898 51.9749 16.7076 51.9749C16.5254 51.9749 16.3887 51.8376 16.3887 51.6545C16.3887 51.4713 16.5254 51.334 16.7076 51.334C16.8898 51.334 17.0265 51.5171 17.0265 51.6545Z",
    fill: "url(#paint97_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 51.6545C19.5343 51.8376 19.3977 51.9749 19.2154 51.9749C19.0332 51.9749 18.8965 51.8376 18.8965 51.6545C18.8965 51.4713 19.0332 51.334 19.2154 51.334C19.3977 51.334 19.5343 51.5171 19.5343 51.6545Z",
    fill: "url(#paint98_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 51.6545C22.0851 51.8376 21.9484 51.9749 21.7662 51.9749C21.5839 51.9749 21.4473 51.8376 21.4473 51.6545C21.4473 51.4713 21.5839 51.334 21.7662 51.334C21.9029 51.334 22.0851 51.5171 22.0851 51.6545Z",
    fill: "url(#paint99_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 51.6545C24.591 51.8376 24.4543 51.9749 24.272 51.9749C24.0898 51.9749 23.9531 51.8376 23.9531 51.6545C23.9531 51.4713 24.0898 51.334 24.272 51.334C24.4543 51.334 24.591 51.5171 24.591 51.6545Z",
    fill: "url(#paint100_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 51.6545C27.0968 51.8376 26.9602 51.9749 26.7779 51.9749C26.5957 51.9749 26.459 51.8376 26.459 51.6545C26.459 51.4713 26.5957 51.334 26.7779 51.334C26.9602 51.334 27.0968 51.5171 27.0968 51.6545Z",
    fill: "url(#paint101_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 51.6545C29.6476 51.8376 29.5109 51.9749 29.3287 51.9749C29.1464 51.9749 29.0098 51.8376 29.0098 51.6545C29.0098 51.4713 29.1464 51.334 29.3287 51.334C29.4654 51.334 29.6476 51.5171 29.6476 51.6545Z",
    fill: "url(#paint102_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1535 51.6545C32.1535 51.8376 32.0168 51.9749 31.8346 51.9749C31.6523 51.9749 31.5156 51.8376 31.5156 51.6545C31.5156 51.4713 31.6523 51.334 31.8346 51.334C32.0168 51.334 32.1535 51.5171 32.1535 51.6545Z",
    fill: "url(#paint103_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9712 53.3967C11.9712 53.534 11.8801 53.6713 11.7434 53.7171C11.6067 53.5798 11.5156 53.3967 11.3789 53.2135C11.4245 53.122 11.5156 53.0762 11.6523 53.0762C11.8345 53.0762 11.9712 53.2135 11.9712 53.3967Z",
    fill: "url(#paint104_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 53.3967C14.4777 53.5798 14.341 53.7171 14.1588 53.7171C13.9765 53.7171 13.8398 53.5798 13.8398 53.3967C13.8398 53.2135 13.9765 53.0762 14.1588 53.0762C14.341 53.0762 14.4777 53.2135 14.4777 53.3967Z",
    fill: "url(#paint105_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 53.3967C17.0265 53.5798 16.8898 53.7171 16.7076 53.7171C16.5254 53.7171 16.3887 53.5798 16.3887 53.3967C16.3887 53.2135 16.5254 53.0762 16.7076 53.0762C16.8898 53.0762 17.0265 53.2135 17.0265 53.3967Z",
    fill: "url(#paint106_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 53.3967C19.5343 53.5798 19.3977 53.7171 19.2154 53.7171C19.0332 53.7171 18.8965 53.5798 18.8965 53.3967C18.8965 53.2135 19.0332 53.0762 19.2154 53.0762C19.3977 53.0762 19.5343 53.2135 19.5343 53.3967Z",
    fill: "url(#paint107_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 53.3967C22.0851 53.5798 21.9484 53.7171 21.7662 53.7171C21.5839 53.7171 21.4473 53.5798 21.4473 53.3967C21.4473 53.2135 21.5839 53.0762 21.7662 53.0762C21.9029 53.0762 22.0851 53.2135 22.0851 53.3967Z",
    fill: "url(#paint108_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 53.3967C24.591 53.5798 24.4543 53.7171 24.272 53.7171C24.0898 53.7171 23.9531 53.5798 23.9531 53.3967C23.9531 53.2135 24.0898 53.0762 24.272 53.0762C24.4543 53.0762 24.591 53.2135 24.591 53.3967Z",
    fill: "url(#paint109_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 53.3967C27.0968 53.5798 26.9602 53.7171 26.7779 53.7171C26.5957 53.7171 26.459 53.5798 26.459 53.3967C26.459 53.2135 26.5957 53.0762 26.7779 53.0762C26.9602 53.0762 27.0968 53.2135 27.0968 53.3967Z",
    fill: "url(#paint110_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 53.3967C29.6476 53.5798 29.5109 53.7171 29.3287 53.7171C29.1464 53.7171 29.0098 53.5798 29.0098 53.3967C29.0098 53.2135 29.1464 53.0762 29.3287 53.0762C29.4654 53.0762 29.6476 53.2135 29.6476 53.3967Z",
    fill: "url(#paint111_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1079 53.2593C32.0168 53.3966 31.8801 53.5798 31.789 53.7171C31.6067 53.7171 31.5156 53.5798 31.5156 53.3967C31.5156 53.2135 31.6523 53.0762 31.8346 53.0762C31.9712 53.0762 32.0624 53.122 32.1079 53.2593Z",
    fill: "url(#paint112_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 55.09C14.4777 55.2731 14.341 55.4105 14.1588 55.4105C13.9765 55.4105 13.8398 55.2731 13.8398 55.09C13.8398 54.9069 13.9765 54.7695 14.1588 54.7695C14.341 54.7695 14.4777 54.9069 14.4777 55.09Z",
    fill: "url(#paint113_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 55.09C17.0265 55.2731 16.8898 55.4105 16.7076 55.4105C16.5254 55.4105 16.3887 55.2731 16.3887 55.09C16.3887 54.9069 16.5254 54.7695 16.7076 54.7695C16.8898 54.7695 17.0265 54.9069 17.0265 55.09Z",
    fill: "url(#paint114_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 55.09C19.5343 55.2731 19.3977 55.4105 19.2154 55.4105C19.0332 55.4105 18.8965 55.2731 18.8965 55.09C18.8965 54.9069 19.0332 54.7695 19.2154 54.7695C19.3977 54.7695 19.5343 54.9069 19.5343 55.09Z",
    fill: "url(#paint115_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 55.09C22.0851 55.2731 21.9484 55.4105 21.7662 55.4105C21.5839 55.4105 21.4473 55.2731 21.4473 55.09C21.4473 54.9069 21.5839 54.7695 21.7662 54.7695C21.9029 54.7695 22.0851 54.9069 22.0851 55.09Z",
    fill: "url(#paint116_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 55.09C24.591 55.2731 24.4543 55.4105 24.272 55.4105C24.0898 55.4105 23.9531 55.2731 23.9531 55.09C23.9531 54.9069 24.0898 54.7695 24.272 54.7695C24.4543 54.7695 24.591 54.9069 24.591 55.09Z",
    fill: "url(#paint117_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 55.09C27.0968 55.2731 26.9602 55.4105 26.7779 55.4105C26.5957 55.4105 26.459 55.2731 26.459 55.09C26.459 54.9069 26.5957 54.7695 26.7779 54.7695C26.9602 54.7695 27.0968 54.9069 27.0968 55.09Z",
    fill: "url(#paint118_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 55.09C29.6476 55.2731 29.5109 55.4105 29.3287 55.4105C29.1464 55.4105 29.0098 55.2731 29.0098 55.09C29.0098 54.9069 29.1464 54.7695 29.3287 54.7695C29.4654 54.7695 29.6476 54.9069 29.6476 55.09Z",
    fill: "url(#paint119_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 57.1038C16.8837 57.1038 17.0265 56.9604 17.0265 56.7834C17.0265 56.6064 16.8837 56.4629 16.7076 56.4629C16.5315 56.4629 16.3887 56.6064 16.3887 56.7834C16.3887 56.9604 16.5315 57.1038 16.7076 57.1038Z",
    fill: "url(#paint120_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 56.7834C19.5343 56.9665 19.3977 57.1038 19.2154 57.1038C19.0332 57.1038 18.8965 56.9665 18.8965 56.7834C18.8965 56.6002 19.0332 56.4629 19.2154 56.4629C19.3977 56.4629 19.5343 56.6002 19.5343 56.7834Z",
    fill: "url(#paint121_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 57.1038C21.8955 57.1038 22.0382 56.9604 22.0382 56.7834C22.0382 56.6064 21.8955 56.4629 21.7193 56.4629C21.5432 56.4629 21.4004 56.6064 21.4004 56.7834C21.4004 56.9604 21.5432 57.1038 21.7193 57.1038Z",
    fill: "url(#paint122_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 56.7834C24.591 56.9665 24.4543 57.1038 24.272 57.1038C24.0898 57.1038 23.9531 56.9665 23.9531 56.7834C23.9531 56.6002 24.0898 56.4629 24.272 56.4629C24.4543 56.4629 24.591 56.6002 24.591 56.7834Z",
    fill: "url(#paint123_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.7779 57.1038C26.954 57.1038 27.0968 56.9604 27.0968 56.7834C27.0968 56.6064 26.954 56.4629 26.7779 56.4629C26.6018 56.4629 26.459 56.6064 26.459 56.7834C26.459 56.9604 26.6018 57.1038 26.7779 57.1038Z",
    fill: "url(#paint124_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5344 58.3864C19.3521 58.3407 19.1699 58.3407 19.0332 58.2949C19.0788 58.2491 19.1699 58.2033 19.261 58.2033C19.3521 58.1575 19.4888 58.2491 19.5344 58.3864Z",
    fill: "url(#paint125_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 58.4767C22.0851 58.5225 22.0851 58.5225 22.0851 58.5683C21.994 58.5683 21.9029 58.5683 21.8118 58.5683C21.6751 58.5683 21.5839 58.5683 21.4473 58.5683C21.4473 58.5225 21.4473 58.5225 21.4473 58.4767C21.4473 58.2936 21.5839 58.1562 21.7662 58.1562C21.9029 58.1562 22.0851 58.2936 22.0851 58.4767Z",
    fill: "url(#paint126_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.4999 58.2936C24.3176 58.3394 24.1354 58.3852 23.9531 58.3852C23.9987 58.2478 24.1354 58.1562 24.2721 58.1562C24.3632 58.1562 24.4543 58.202 24.4999 58.2936Z",
    fill: "url(#paint127_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60146 46.5744C9.60146 46.7575 9.46477 46.8949 9.28253 46.8949H9.23697C9.23697 46.6659 9.19141 46.4828 9.19141 46.2539C9.23697 46.2539 9.23697 46.2539 9.28253 46.2539C9.46477 46.2539 9.60146 46.3913 9.60146 46.5744Z",
    fill: "url(#paint128_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60146 44.8786C9.60146 45.0618 9.46477 45.1991 9.28253 45.1991C9.23697 45.1991 9.23697 45.1991 9.19141 45.1991C9.19141 44.9702 9.23697 44.7871 9.23697 44.5581H9.28253C9.46477 44.5124 9.60146 44.6955 9.60146 44.8786Z",
    fill: "url(#paint129_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.60149 48.2669C9.60149 48.3584 9.55593 48.45 9.46481 48.5416C9.41925 48.3584 9.37369 48.1753 9.32812 47.9922C9.46481 47.9922 9.60149 48.1295 9.60149 48.2669Z",
    fill: "url(#paint130_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.46417 42.9121C9.55529 42.9579 9.60085 43.0495 9.60085 43.141C9.60085 43.2784 9.50973 43.4157 9.37305 43.4615C9.37305 43.2784 9.41861 43.0952 9.46417 42.9121Z",
    fill: "url(#paint131_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 51.6545C11.9699 51.8376 11.8332 51.9749 11.651 51.9749C11.4687 51.9749 11.332 51.8376 11.332 51.6545C11.332 51.4713 11.4687 51.334 11.651 51.334C11.8332 51.334 11.9699 51.5171 11.9699 51.6545Z",
    fill: "url(#paint132_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 49.9611C11.9699 50.1442 11.8332 50.2816 11.651 50.2816C11.4687 50.2816 11.332 50.1442 11.332 49.9611C11.332 49.778 11.4687 49.6406 11.651 49.6406C11.8332 49.6406 11.9699 49.778 11.9699 49.9611Z",
    fill: "url(#paint133_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 48.2677C11.9699 48.4509 11.8332 48.5882 11.651 48.5882C11.4687 48.5882 11.332 48.4509 11.332 48.2677C11.332 48.0846 11.4687 47.9473 11.651 47.9473C11.8332 47.9473 11.9699 48.0846 11.9699 48.2677Z",
    fill: "url(#paint134_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 46.5744C11.9699 46.7575 11.8332 46.8949 11.651 46.8949C11.4687 46.8949 11.332 46.7575 11.332 46.5744C11.332 46.3913 11.4687 46.2539 11.651 46.2539C11.8332 46.2539 11.9699 46.3913 11.9699 46.5744Z",
    fill: "url(#paint135_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 44.8784C11.9699 45.0615 11.8332 45.1989 11.651 45.1989C11.4687 45.1989 11.332 45.0615 11.332 44.8784C11.332 44.6952 11.4687 44.5579 11.651 44.5579C11.8332 44.5121 11.9699 44.6952 11.9699 44.8784Z",
    fill: "url(#paint136_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 43.1427C11.9699 43.3259 11.8332 43.4632 11.651 43.4632C11.4687 43.4632 11.332 43.3259 11.332 43.1427C11.332 42.9596 11.4687 42.8223 11.651 42.8223C11.8332 42.8223 11.9699 42.9596 11.9699 43.1427Z",
    fill: "url(#paint137_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 41.4455C11.9699 41.6286 11.8332 41.766 11.651 41.766C11.4687 41.766 11.332 41.6286 11.332 41.4455C11.332 41.2623 11.4687 41.125 11.651 41.125C11.8332 41.125 11.9699 41.2623 11.9699 41.4455Z",
    fill: "url(#paint138_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9699 39.7521C11.9699 39.9352 11.8332 40.0726 11.651 40.0726C11.4687 40.0726 11.332 39.9352 11.332 39.7521C11.332 39.569 11.4687 39.4316 11.651 39.4316C11.8332 39.4316 11.9699 39.569 11.9699 39.7521Z",
    fill: "url(#paint139_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9712 53.3967C11.9712 53.534 11.8801 53.6713 11.7434 53.7171C11.6067 53.5798 11.5156 53.3967 11.3789 53.2135C11.4245 53.122 11.5156 53.0762 11.6523 53.0762C11.8345 53.0762 11.9712 53.2135 11.9712 53.3967Z",
    fill: "url(#paint140_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.9706 38.0579C11.9706 38.241 11.8339 38.3784 11.6516 38.3784C11.5605 38.3784 11.4694 38.3326 11.4238 38.2868C11.5605 38.1037 11.6972 37.9663 11.7883 37.7832C11.925 37.7832 11.9706 37.9206 11.9706 38.0579Z",
    fill: "url(#paint141_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 55.09C14.4777 55.2731 14.341 55.4105 14.1588 55.4105C13.9765 55.4105 13.8398 55.2731 13.8398 55.09C13.8398 54.9069 13.9765 54.7695 14.1588 54.7695C14.341 54.7695 14.4777 54.9069 14.4777 55.09Z",
    fill: "url(#paint142_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 53.3967C14.4777 53.5798 14.341 53.7171 14.1588 53.7171C13.9765 53.7171 13.8398 53.5798 13.8398 53.3967C13.8398 53.2135 13.9765 53.0762 14.1588 53.0762C14.341 53.0762 14.4777 53.2135 14.4777 53.3967Z",
    fill: "url(#paint143_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 51.6545C14.4777 51.8376 14.341 51.9749 14.1588 51.9749C13.9765 51.9749 13.8398 51.8376 13.8398 51.6545C13.8398 51.4713 13.9765 51.334 14.1588 51.334C14.341 51.334 14.4777 51.5171 14.4777 51.6545Z",
    fill: "url(#paint144_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 49.9611C14.4777 50.1442 14.341 50.2816 14.1588 50.2816C13.9765 50.2816 13.8398 50.1442 13.8398 49.9611C13.8398 49.778 13.9765 49.6406 14.1588 49.6406C14.341 49.6406 14.4777 49.778 14.4777 49.9611Z",
    fill: "url(#paint145_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 48.2677C14.4777 48.4509 14.341 48.5882 14.1588 48.5882C13.9765 48.5882 13.8398 48.4509 13.8398 48.2677C13.8398 48.0846 13.9765 47.9473 14.1588 47.9473C14.341 47.9473 14.4777 48.0846 14.4777 48.2677Z",
    fill: "url(#paint146_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 46.5744C14.4777 46.7575 14.341 46.8949 14.1588 46.8949C13.9765 46.8949 13.8398 46.7575 13.8398 46.5744C13.8398 46.3913 13.9765 46.2539 14.1588 46.2539C14.341 46.2539 14.4777 46.3913 14.4777 46.5744Z",
    fill: "url(#paint147_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 44.8784C14.4777 45.0615 14.341 45.1989 14.1588 45.1989C13.9765 45.1989 13.8398 45.0615 13.8398 44.8784C13.8398 44.6952 13.9765 44.5579 14.1588 44.5579C14.341 44.5121 14.4777 44.6952 14.4777 44.8784Z",
    fill: "url(#paint148_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 43.1427C14.4777 43.3259 14.341 43.4632 14.1588 43.4632C13.9765 43.4632 13.8398 43.3259 13.8398 43.1427C13.8398 42.9596 13.9765 42.8223 14.1588 42.8223C14.341 42.8223 14.4777 42.9596 14.4777 43.1427Z",
    fill: "url(#paint149_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 41.4455C14.4777 41.6286 14.341 41.766 14.1588 41.766C13.9765 41.766 13.8398 41.6286 13.8398 41.4455C13.8398 41.2623 13.9765 41.125 14.1588 41.125C14.341 41.125 14.4777 41.2623 14.4777 41.4455Z",
    fill: "url(#paint150_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 39.7521C14.4777 39.9352 14.341 40.0726 14.1588 40.0726C13.9765 40.0726 13.8398 39.9352 13.8398 39.7521C13.8398 39.569 13.9765 39.4316 14.1588 39.4316C14.341 39.4316 14.4777 39.569 14.4777 39.7521Z",
    fill: "url(#paint151_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 38.0588C14.4777 38.2419 14.341 38.3792 14.1588 38.3792C13.9765 38.3792 13.8398 38.2419 13.8398 38.0588C13.8398 37.8756 13.9765 37.7383 14.1588 37.7383C14.341 37.7383 14.4777 37.8756 14.4777 38.0588Z",
    fill: "url(#paint152_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.4777 36.3185C14.4777 36.5017 14.341 36.639 14.1588 36.639C13.9765 36.639 13.8398 36.5017 13.8398 36.3185C13.8398 36.1354 13.9765 35.998 14.1588 35.998C14.341 35.998 14.4777 36.1812 14.4777 36.3185Z",
    fill: "url(#paint153_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 57.1038C16.8837 57.1038 17.0265 56.9604 17.0265 56.7834C17.0265 56.6064 16.8837 56.4629 16.7076 56.4629C16.5315 56.4629 16.3887 56.6064 16.3887 56.7834C16.3887 56.9604 16.5315 57.1038 16.7076 57.1038Z",
    fill: "url(#paint154_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 55.09C17.0265 55.2731 16.8898 55.4105 16.7076 55.4105C16.5254 55.4105 16.3887 55.2731 16.3887 55.09C16.3887 54.9069 16.5254 54.7695 16.7076 54.7695C16.8898 54.7695 17.0265 54.9069 17.0265 55.09Z",
    fill: "url(#paint155_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 53.3967C17.0265 53.5798 16.8898 53.7171 16.7076 53.7171C16.5254 53.7171 16.3887 53.5798 16.3887 53.3967C16.3887 53.2135 16.5254 53.0762 16.7076 53.0762C16.8898 53.0762 17.0265 53.2135 17.0265 53.3967Z",
    fill: "url(#paint156_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 51.6545C17.0265 51.8376 16.8898 51.9749 16.7076 51.9749C16.5254 51.9749 16.3887 51.8376 16.3887 51.6545C16.3887 51.4713 16.5254 51.334 16.7076 51.334C16.8898 51.334 17.0265 51.5171 17.0265 51.6545Z",
    fill: "url(#paint157_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 49.9611C17.0265 50.1442 16.8898 50.2816 16.7076 50.2816C16.5254 50.2816 16.3887 50.1442 16.3887 49.9611C16.3887 49.778 16.5254 49.6406 16.7076 49.6406C16.8898 49.6406 17.0265 49.778 17.0265 49.9611Z",
    fill: "url(#paint158_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 48.2677C17.0265 48.4509 16.8898 48.5882 16.7076 48.5882C16.5254 48.5882 16.3887 48.4509 16.3887 48.2677C16.3887 48.0846 16.5254 47.9473 16.7076 47.9473C16.8898 47.9473 17.0265 48.0846 17.0265 48.2677Z",
    fill: "url(#paint159_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 46.8949C16.8837 46.8949 17.0265 46.7514 17.0265 46.5744C17.0265 46.3974 16.8837 46.2539 16.7076 46.2539C16.5315 46.2539 16.3887 46.3974 16.3887 46.5744C16.3887 46.7514 16.5315 46.8949 16.7076 46.8949Z",
    fill: "url(#paint160_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 44.8784C17.0265 45.0615 16.8898 45.1989 16.7076 45.1989C16.5254 45.1989 16.3887 45.0615 16.3887 44.8784C16.3887 44.6952 16.5254 44.5579 16.7076 44.5579C16.8898 44.5121 17.0265 44.6952 17.0265 44.8784Z",
    fill: "url(#paint161_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 43.4632C16.8837 43.4632 17.0265 43.3197 17.0265 43.1427C17.0265 42.9657 16.8837 42.8223 16.7076 42.8223C16.5315 42.8223 16.3887 42.9657 16.3887 43.1427C16.3887 43.3197 16.5315 43.4632 16.7076 43.4632Z",
    fill: "url(#paint162_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 41.4455C17.0265 41.6286 16.8898 41.766 16.7076 41.766C16.5254 41.766 16.3887 41.6286 16.3887 41.4455C16.3887 41.2623 16.5254 41.125 16.7076 41.125C16.8898 41.125 17.0265 41.2623 17.0265 41.4455Z",
    fill: "url(#paint163_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 39.7521C17.0265 39.9352 16.8898 40.0726 16.7076 40.0726C16.5254 40.0726 16.3887 39.9352 16.3887 39.7521C16.3887 39.569 16.5254 39.4316 16.7076 39.4316C16.8898 39.4316 17.0265 39.569 17.0265 39.7521Z",
    fill: "url(#paint164_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 38.3792C16.8837 38.3792 17.0265 38.2358 17.0265 38.0588C17.0265 37.8818 16.8837 37.7383 16.7076 37.7383C16.5315 37.7383 16.3887 37.8818 16.3887 38.0588C16.3887 38.2358 16.5315 38.3792 16.7076 38.3792Z",
    fill: "url(#paint165_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.7076 36.639C16.8837 36.639 17.0265 36.4955 17.0265 36.3185C17.0265 36.1415 16.8837 35.998 16.7076 35.998C16.5315 35.998 16.3887 36.1415 16.3887 36.3185C16.3887 36.4955 16.5315 36.639 16.7076 36.639Z",
    fill: "url(#paint166_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.0265 34.6252C17.0265 34.8083 16.8898 34.9456 16.7076 34.9456C16.5254 34.9456 16.3887 34.8083 16.3887 34.6252C16.3887 34.442 16.5254 34.3047 16.7076 34.3047C16.8898 34.3047 17.0265 34.442 17.0265 34.6252Z",
    fill: "url(#paint167_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.2148 33.386C19.1236 33.386 18.987 33.3402 18.9414 33.2487C19.1237 33.2029 19.3059 33.1571 19.5337 33.1113C19.4881 33.2487 19.397 33.386 19.2148 33.386Z",
    fill: "url(#paint168_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 56.7834C19.5343 56.9665 19.3977 57.1038 19.2154 57.1038C19.0332 57.1038 18.8965 56.9665 18.8965 56.7834C18.8965 56.6002 19.0332 56.4629 19.2154 56.4629C19.3977 56.4629 19.5343 56.6002 19.5343 56.7834Z",
    fill: "url(#paint169_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 55.09C19.5343 55.2731 19.3977 55.4105 19.2154 55.4105C19.0332 55.4105 18.8965 55.2731 18.8965 55.09C18.8965 54.9069 19.0332 54.7695 19.2154 54.7695C19.3977 54.7695 19.5343 54.9069 19.5343 55.09Z",
    fill: "url(#paint170_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 53.3967C19.5343 53.5798 19.3977 53.7171 19.2154 53.7171C19.0332 53.7171 18.8965 53.5798 18.8965 53.3967C18.8965 53.2135 19.0332 53.0762 19.2154 53.0762C19.3977 53.0762 19.5343 53.2135 19.5343 53.3967Z",
    fill: "url(#paint171_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 51.6545C19.5343 51.8376 19.3977 51.9749 19.2154 51.9749C19.0332 51.9749 18.8965 51.8376 18.8965 51.6545C18.8965 51.4713 19.0332 51.334 19.2154 51.334C19.3977 51.334 19.5343 51.5171 19.5343 51.6545Z",
    fill: "url(#paint172_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 49.9611C19.5343 50.1442 19.3977 50.2816 19.2154 50.2816C19.0332 50.2816 18.8965 50.1442 18.8965 49.9611C18.8965 49.778 19.0332 49.6406 19.2154 49.6406C19.3977 49.6406 19.5343 49.778 19.5343 49.9611Z",
    fill: "url(#paint173_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 48.2677C19.5343 48.4509 19.3977 48.5882 19.2154 48.5882C19.0332 48.5882 18.8965 48.4509 18.8965 48.2677C18.8965 48.0846 19.0332 47.9473 19.2154 47.9473C19.3977 47.9473 19.5343 48.0846 19.5343 48.2677Z",
    fill: "url(#paint174_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 46.5744C19.5343 46.7575 19.3977 46.8949 19.2154 46.8949C19.0332 46.8949 18.8965 46.7575 18.8965 46.5744C18.8965 46.3913 19.0332 46.2539 19.2154 46.2539C19.3977 46.2539 19.5343 46.3913 19.5343 46.5744Z",
    fill: "url(#paint175_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 44.8784C19.5343 45.0615 19.3977 45.1989 19.2154 45.1989C19.0332 45.1989 18.8965 45.0615 18.8965 44.8784C18.8965 44.6952 19.0332 44.5579 19.2154 44.5579C19.3977 44.5121 19.5343 44.6952 19.5343 44.8784Z",
    fill: "url(#paint176_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 43.1427C19.5343 43.3259 19.3977 43.4632 19.2154 43.4632C19.0332 43.4632 18.8965 43.3259 18.8965 43.1427C18.8965 42.9596 19.0332 42.8223 19.2154 42.8223C19.3977 42.8223 19.5343 42.9596 19.5343 43.1427Z",
    fill: "url(#paint177_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 41.4455C19.5343 41.6286 19.3977 41.766 19.2154 41.766C19.0332 41.766 18.8965 41.6286 18.8965 41.4455C18.8965 41.2623 19.0332 41.125 19.2154 41.125C19.3977 41.125 19.5343 41.2623 19.5343 41.4455Z",
    fill: "url(#paint178_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 39.7521C19.5343 39.9352 19.3977 40.0726 19.2154 40.0726C19.0332 40.0726 18.8965 39.9352 18.8965 39.7521C18.8965 39.569 19.0332 39.4316 19.2154 39.4316C19.3977 39.4316 19.5343 39.569 19.5343 39.7521Z",
    fill: "url(#paint179_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 38.0588C19.5343 38.2419 19.3977 38.3792 19.2154 38.3792C19.0332 38.3792 18.8965 38.2419 18.8965 38.0588C18.8965 37.8756 19.0332 37.7383 19.2154 37.7383C19.3977 37.7383 19.5343 37.8756 19.5343 38.0588Z",
    fill: "url(#paint180_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 36.3185C19.5343 36.5017 19.3977 36.639 19.2154 36.639C19.0332 36.639 18.8965 36.5017 18.8965 36.3185C18.8965 36.1354 19.0332 35.998 19.2154 35.998C19.3977 35.998 19.5343 36.1812 19.5343 36.3185Z",
    fill: "url(#paint181_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5343 34.6252C19.5343 34.8083 19.3977 34.9456 19.2154 34.9456C19.0332 34.9456 18.8965 34.8083 18.8965 34.6252C18.8965 34.442 19.0332 34.3047 19.2154 34.3047C19.3977 34.3047 19.5343 34.442 19.5343 34.6252Z",
    fill: "url(#paint182_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5344 58.3864C19.3521 58.3407 19.1699 58.3407 19.0332 58.2949C19.0788 58.2491 19.1699 58.2033 19.261 58.2033C19.3521 58.1575 19.4888 58.2491 19.5344 58.3864Z",
    fill: "url(#paint183_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 57.1038C21.8955 57.1038 22.0382 56.9604 22.0382 56.7834C22.0382 56.6064 21.8955 56.4629 21.7193 56.4629C21.5432 56.4629 21.4004 56.6064 21.4004 56.7834C21.4004 56.9604 21.5432 57.1038 21.7193 57.1038Z",
    fill: "url(#paint184_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 55.09C22.0851 55.2731 21.9484 55.4105 21.7662 55.4105C21.5839 55.4105 21.4473 55.2731 21.4473 55.09C21.4473 54.9069 21.5839 54.7695 21.7662 54.7695C21.9029 54.7695 22.0851 54.9069 22.0851 55.09Z",
    fill: "url(#paint185_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 53.3967C22.0851 53.5798 21.9484 53.7171 21.7662 53.7171C21.5839 53.7171 21.4473 53.5798 21.4473 53.3967C21.4473 53.2135 21.5839 53.0762 21.7662 53.0762C21.9029 53.0762 22.0851 53.2135 22.0851 53.3967Z",
    fill: "url(#paint186_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 51.6545C22.0851 51.8376 21.9484 51.9749 21.7662 51.9749C21.5839 51.9749 21.4473 51.8376 21.4473 51.6545C21.4473 51.4713 21.5839 51.334 21.7662 51.334C21.9029 51.334 22.0851 51.5171 22.0851 51.6545Z",
    fill: "url(#paint187_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 49.9614C22.0851 50.1445 21.9484 50.2818 21.7662 50.2818C21.5839 50.2818 21.4473 50.1445 21.4473 49.9614C21.4473 49.7782 21.5839 49.6409 21.7662 49.6409C21.9029 49.6409 22.0851 49.7782 22.0851 49.9614Z",
    fill: "url(#paint188_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 48.268C22.0851 48.4511 21.9484 48.5885 21.7662 48.5885C21.5839 48.5885 21.4473 48.4511 21.4473 48.268C21.4473 48.0849 21.5839 47.9475 21.7662 47.9475C21.9029 47.9475 22.0851 48.0849 22.0851 48.268Z",
    fill: "url(#paint189_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 46.8949C21.8955 46.8949 22.0382 46.7514 22.0382 46.5744C22.0382 46.3974 21.8955 46.2539 21.7193 46.2539C21.5432 46.2539 21.4004 46.3974 21.4004 46.5744C21.4004 46.7514 21.5432 46.8949 21.7193 46.8949Z",
    fill: "url(#paint190_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 44.8786C22.0851 45.0618 21.9484 45.1991 21.7662 45.1991C21.5839 45.1991 21.4473 45.0618 21.4473 44.8786C21.4473 44.6955 21.5839 44.5581 21.7662 44.5581C21.9029 44.5124 22.0851 44.6955 22.0851 44.8786Z",
    fill: "url(#paint191_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 43.4632C21.8955 43.4632 22.0382 43.3197 22.0382 43.1427C22.0382 42.9657 21.8955 42.8223 21.7193 42.8223C21.5432 42.8223 21.4004 42.9657 21.4004 43.1427C21.4004 43.3197 21.5432 43.4632 21.7193 43.4632Z",
    fill: "url(#paint192_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 41.4455C22.0851 41.6286 21.9484 41.766 21.7662 41.766C21.5839 41.766 21.4473 41.6286 21.4473 41.4455C21.4473 41.2623 21.5839 41.125 21.7662 41.125C21.9029 41.125 22.0851 41.2623 22.0851 41.4455Z",
    fill: "url(#paint193_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 39.7521C22.0851 39.9352 21.9484 40.0726 21.7662 40.0726C21.5839 40.0726 21.4473 39.9352 21.4473 39.7521C21.4473 39.569 21.5839 39.4316 21.7662 39.4316C21.9029 39.4316 22.0851 39.569 22.0851 39.7521Z",
    fill: "url(#paint194_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 38.3792C21.8955 38.3792 22.0382 38.2358 22.0382 38.0588C22.0382 37.8818 21.8955 37.7383 21.7193 37.7383C21.5432 37.7383 21.4004 37.8818 21.4004 38.0588C21.4004 38.2358 21.5432 38.3792 21.7193 38.3792Z",
    fill: "url(#paint195_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.7193 36.639C21.8955 36.639 22.0382 36.4955 22.0382 36.3185C22.0382 36.1415 21.8955 35.998 21.7193 35.998C21.5432 35.998 21.4004 36.1415 21.4004 36.3185C21.4004 36.4955 21.5432 36.639 21.7193 36.639Z",
    fill: "url(#paint196_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 34.6252C22.0851 34.8083 21.9484 34.9456 21.7662 34.9456C21.5839 34.9456 21.4473 34.8083 21.4473 34.6252C21.4473 34.442 21.5839 34.3047 21.7662 34.3047C21.9029 34.3047 22.0851 34.442 22.0851 34.6252Z",
    fill: "url(#paint197_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0396 32.9297C22.0396 32.9755 22.0851 33.0213 22.0851 33.067C22.0851 33.2502 21.9484 33.3875 21.7662 33.3875C21.5839 33.3875 21.4473 33.2502 21.4473 33.067C21.4473 33.0213 21.4473 32.9755 21.4928 32.9297C21.5839 32.9297 21.7206 32.9297 21.8118 32.9297C21.8573 32.9297 21.9484 32.9297 22.0396 32.9297Z",
    fill: "url(#paint198_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.0851 58.4767C22.0851 58.5225 22.0851 58.5225 22.0851 58.5683C21.994 58.5683 21.9029 58.5683 21.8118 58.5683C21.6751 58.5683 21.5839 58.5683 21.4473 58.5683C21.4473 58.5225 21.4473 58.5225 21.4473 58.4767C21.4473 58.2936 21.5839 58.1562 21.7662 58.1562C21.9029 58.1562 22.0851 58.2936 22.0851 58.4767Z",
    fill: "url(#paint199_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 56.7834C24.591 56.9665 24.4543 57.1038 24.272 57.1038C24.0898 57.1038 23.9531 56.9665 23.9531 56.7834C23.9531 56.6002 24.0898 56.4629 24.272 56.4629C24.4543 56.4629 24.591 56.6002 24.591 56.7834Z",
    fill: "url(#paint200_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 55.09C24.591 55.2731 24.4543 55.4105 24.272 55.4105C24.0898 55.4105 23.9531 55.2731 23.9531 55.09C23.9531 54.9069 24.0898 54.7695 24.272 54.7695C24.4543 54.7695 24.591 54.9069 24.591 55.09Z",
    fill: "url(#paint201_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 53.3967C24.591 53.5798 24.4543 53.7171 24.272 53.7171C24.0898 53.7171 23.9531 53.5798 23.9531 53.3967C23.9531 53.2135 24.0898 53.0762 24.272 53.0762C24.4543 53.0762 24.591 53.2135 24.591 53.3967Z",
    fill: "url(#paint202_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 51.6545C24.591 51.8376 24.4543 51.9749 24.272 51.9749C24.0898 51.9749 23.9531 51.8376 23.9531 51.6545C23.9531 51.4713 24.0898 51.334 24.272 51.334C24.4543 51.334 24.591 51.5171 24.591 51.6545Z",
    fill: "url(#paint203_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 49.9611C24.591 50.1442 24.4543 50.2816 24.272 50.2816C24.0898 50.2816 23.9531 50.1442 23.9531 49.9611C23.9531 49.778 24.0898 49.6406 24.272 49.6406C24.4543 49.6406 24.591 49.778 24.591 49.9611Z",
    fill: "url(#paint204_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 48.2677C24.591 48.4509 24.4543 48.5882 24.272 48.5882C24.0898 48.5882 23.9531 48.4509 23.9531 48.2677C23.9531 48.0846 24.0898 47.9473 24.272 47.9473C24.4543 47.9473 24.591 48.0846 24.591 48.2677Z",
    fill: "url(#paint205_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 46.5744C24.591 46.7575 24.4543 46.8949 24.272 46.8949C24.0898 46.8949 23.9531 46.7575 23.9531 46.5744C23.9531 46.3913 24.0898 46.2539 24.272 46.2539C24.4543 46.2539 24.591 46.3913 24.591 46.5744Z",
    fill: "url(#paint206_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 44.8784C24.591 45.0615 24.4543 45.1989 24.272 45.1989C24.0898 45.1989 23.9531 45.0615 23.9531 44.8784C23.9531 44.6952 24.0898 44.5579 24.272 44.5579C24.4543 44.5121 24.591 44.6952 24.591 44.8784Z",
    fill: "url(#paint207_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 43.1427C24.591 43.3259 24.4543 43.4632 24.272 43.4632C24.0898 43.4632 23.9531 43.3259 23.9531 43.1427C23.9531 42.9596 24.0898 42.8223 24.272 42.8223C24.4543 42.8223 24.591 42.9596 24.591 43.1427Z",
    fill: "url(#paint208_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 41.4455C24.591 41.6286 24.4543 41.766 24.272 41.766C24.0898 41.766 23.9531 41.6286 23.9531 41.4455C23.9531 41.2623 24.0898 41.125 24.272 41.125C24.4543 41.125 24.591 41.2623 24.591 41.4455Z",
    fill: "url(#paint209_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 39.7521C24.591 39.9352 24.4543 40.0726 24.272 40.0726C24.0898 40.0726 23.9531 39.9352 23.9531 39.7521C23.9531 39.569 24.0898 39.4316 24.272 39.4316C24.4543 39.4316 24.591 39.569 24.591 39.7521Z",
    fill: "url(#paint210_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 38.0588C24.591 38.2419 24.4543 38.3792 24.272 38.3792C24.0898 38.3792 23.9531 38.2419 23.9531 38.0588C23.9531 37.8756 24.0898 37.7383 24.272 37.7383C24.4543 37.7383 24.591 37.8756 24.591 38.0588Z",
    fill: "url(#paint211_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 36.3185C24.591 36.5017 24.4543 36.639 24.272 36.639C24.0898 36.639 23.9531 36.5017 23.9531 36.3185C23.9531 36.1354 24.0898 35.998 24.272 35.998C24.4543 35.998 24.591 36.1812 24.591 36.3185Z",
    fill: "url(#paint212_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.591 34.6252C24.591 34.8083 24.4543 34.9456 24.272 34.9456C24.0898 34.9456 23.9531 34.8083 23.9531 34.6252C23.9531 34.442 24.0898 34.3047 24.272 34.3047C24.4543 34.3047 24.591 34.442 24.591 34.6252Z",
    fill: "url(#paint213_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.2721 58.1562C24.3632 58.1562 24.4543 58.202 24.4999 58.2478C24.3176 58.2936 24.1354 58.3394 23.9531 58.3394C23.9987 58.2478 24.1354 58.1562 24.2721 58.1562Z",
    fill: "url(#paint214_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M23.9531 33.1113C24.1354 33.1571 24.3632 33.2029 24.5454 33.2487C24.4999 33.3402 24.4087 33.386 24.272 33.386C24.0898 33.386 23.9531 33.2487 23.9531 33.1113Z",
    fill: "url(#paint215_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.7779 57.1038C26.954 57.1038 27.0968 56.9604 27.0968 56.7834C27.0968 56.6064 26.954 56.4629 26.7779 56.4629C26.6018 56.4629 26.459 56.6064 26.459 56.7834C26.459 56.9604 26.6018 57.1038 26.7779 57.1038Z",
    fill: "url(#paint216_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 55.09C27.0968 55.2731 26.9602 55.4105 26.7779 55.4105C26.5957 55.4105 26.459 55.2731 26.459 55.09C26.459 54.9069 26.5957 54.7695 26.7779 54.7695C26.9602 54.7695 27.0968 54.9069 27.0968 55.09Z",
    fill: "url(#paint217_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 53.3967C27.0968 53.5798 26.9602 53.7171 26.7779 53.7171C26.5957 53.7171 26.459 53.5798 26.459 53.3967C26.459 53.2135 26.5957 53.0762 26.7779 53.0762C26.9602 53.0762 27.0968 53.2135 27.0968 53.3967Z",
    fill: "url(#paint218_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 51.6545C27.0968 51.8376 26.9602 51.9749 26.7779 51.9749C26.5957 51.9749 26.459 51.8376 26.459 51.6545C26.459 51.4713 26.5957 51.334 26.7779 51.334C26.9602 51.334 27.0968 51.5171 27.0968 51.6545Z",
    fill: "url(#paint219_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.097 49.9614C27.097 50.1445 26.9603 50.2818 26.778 50.2818C26.5958 50.2818 26.4591 50.1445 26.4591 49.9614C26.4591 49.7782 26.5958 49.6409 26.778 49.6409C26.9603 49.6409 27.097 49.7782 27.097 49.9614Z",
    fill: "url(#paint220_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.097 48.268C27.097 48.4511 26.9603 48.5885 26.778 48.5885C26.5958 48.5885 26.4591 48.4511 26.4591 48.268C26.4591 48.0849 26.5958 47.9475 26.778 47.9475C26.9603 47.9475 27.097 48.0849 27.097 48.268Z",
    fill: "url(#paint221_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.778 46.8949C26.9542 46.8949 27.097 46.7514 27.097 46.5744C27.097 46.3974 26.9542 46.2539 26.778 46.2539C26.6019 46.2539 26.4591 46.3974 26.4591 46.5744C26.4591 46.7514 26.6019 46.8949 26.778 46.8949Z",
    fill: "url(#paint222_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.097 44.8786C27.097 45.0618 26.9603 45.1991 26.778 45.1991C26.5958 45.1991 26.4591 45.0618 26.4591 44.8786C26.4591 44.6955 26.5958 44.5581 26.778 44.5581C26.9603 44.5124 27.097 44.6955 27.097 44.8786Z",
    fill: "url(#paint223_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.778 43.4635C26.9542 43.4635 27.097 43.32 27.097 43.143C27.097 42.966 26.9542 42.8225 26.778 42.8225C26.6019 42.8225 26.4591 42.966 26.4591 43.143C26.4591 43.32 26.6019 43.4635 26.778 43.4635Z",
    fill: "url(#paint224_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 41.4455C27.0968 41.6286 26.9602 41.766 26.7779 41.766C26.5957 41.766 26.459 41.6286 26.459 41.4455C26.459 41.2623 26.5957 41.125 26.7779 41.125C26.9602 41.125 27.0968 41.2623 27.0968 41.4455Z",
    fill: "url(#paint225_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 39.7521C27.0968 39.9352 26.9602 40.0726 26.7779 40.0726C26.5957 40.0726 26.459 39.9352 26.459 39.7521C26.459 39.569 26.5957 39.4316 26.7779 39.4316C26.9602 39.4316 27.0968 39.569 27.0968 39.7521Z",
    fill: "url(#paint226_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.7779 38.3792C26.954 38.3792 27.0968 38.2358 27.0968 38.0588C27.0968 37.8818 26.954 37.7383 26.7779 37.7383C26.6018 37.7383 26.459 37.8818 26.459 38.0588C26.459 38.2358 26.6018 38.3792 26.7779 38.3792Z",
    fill: "url(#paint227_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.7779 36.639C26.954 36.639 27.0968 36.4955 27.0968 36.3185C27.0968 36.1415 26.954 35.998 26.7779 35.998C26.6018 35.998 26.459 36.1415 26.459 36.3185C26.459 36.4955 26.6018 36.639 26.7779 36.639Z",
    fill: "url(#paint228_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.0968 34.6252C27.0968 34.8083 26.9602 34.9456 26.7779 34.9456C26.5957 34.9456 26.459 34.8083 26.459 34.6252C26.459 34.442 26.5957 34.3047 26.7779 34.3047C26.9602 34.3047 27.0968 34.442 27.0968 34.6252Z",
    fill: "url(#paint229_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 55.09C29.6476 55.2731 29.5109 55.4105 29.3287 55.4105C29.1464 55.4105 29.0098 55.2731 29.0098 55.09C29.0098 54.9069 29.1464 54.7695 29.3287 54.7695C29.4654 54.7695 29.6476 54.9069 29.6476 55.09Z",
    fill: "url(#paint230_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 53.3967C29.6476 53.5798 29.5109 53.7171 29.3287 53.7171C29.1464 53.7171 29.0098 53.5798 29.0098 53.3967C29.0098 53.2135 29.1464 53.0762 29.3287 53.0762C29.4654 53.0762 29.6476 53.2135 29.6476 53.3967Z",
    fill: "url(#paint231_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 51.6545C29.6476 51.8376 29.5109 51.9749 29.3287 51.9749C29.1464 51.9749 29.0098 51.8376 29.0098 51.6545C29.0098 51.4713 29.1464 51.334 29.3287 51.334C29.4654 51.334 29.6476 51.5171 29.6476 51.6545Z",
    fill: "url(#paint232_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 49.9611C29.6476 50.1442 29.5109 50.2816 29.3287 50.2816C29.1464 50.2816 29.0098 50.1442 29.0098 49.9611C29.0098 49.778 29.1464 49.6406 29.3287 49.6406C29.4654 49.6406 29.6476 49.778 29.6476 49.9611Z",
    fill: "url(#paint233_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 48.2677C29.6476 48.4509 29.5109 48.5882 29.3287 48.5882C29.1464 48.5882 29.0098 48.4509 29.0098 48.2677C29.0098 48.0846 29.1464 47.9473 29.3287 47.9473C29.4654 47.9473 29.6476 48.0846 29.6476 48.2677Z",
    fill: "url(#paint234_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 46.5744C29.6476 46.7575 29.5109 46.8949 29.3287 46.8949C29.1464 46.8949 29.0098 46.7575 29.0098 46.5744C29.0098 46.3913 29.1464 46.2539 29.3287 46.2539C29.4654 46.2539 29.6476 46.3913 29.6476 46.5744Z",
    fill: "url(#paint235_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 44.8784C29.6476 45.0615 29.5109 45.1989 29.3287 45.1989C29.1464 45.1989 29.0098 45.0615 29.0098 44.8784C29.0098 44.6952 29.1464 44.5579 29.3287 44.5579C29.4654 44.5121 29.6476 44.6952 29.6476 44.8784Z",
    fill: "url(#paint236_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 43.1427C29.6476 43.3259 29.5109 43.4632 29.3287 43.4632C29.1464 43.4632 29.0098 43.3259 29.0098 43.1427C29.0098 42.9596 29.1464 42.8223 29.3287 42.8223C29.4654 42.8223 29.6476 42.9596 29.6476 43.1427Z",
    fill: "url(#paint237_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 41.4455C29.6476 41.6286 29.5109 41.766 29.3287 41.766C29.1464 41.766 29.0098 41.6286 29.0098 41.4455C29.0098 41.2623 29.1464 41.125 29.3287 41.125C29.4654 41.125 29.6476 41.2623 29.6476 41.4455Z",
    fill: "url(#paint238_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 39.7521C29.6476 39.9352 29.5109 40.0726 29.3287 40.0726C29.1464 40.0726 29.0098 39.9352 29.0098 39.7521C29.0098 39.569 29.1464 39.4316 29.3287 39.4316C29.4654 39.4316 29.6476 39.569 29.6476 39.7521Z",
    fill: "url(#paint239_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 38.0588C29.6476 38.2419 29.5109 38.3792 29.3287 38.3792C29.1464 38.3792 29.0098 38.2419 29.0098 38.0588C29.0098 37.8756 29.1464 37.7383 29.3287 37.7383C29.4654 37.7383 29.6476 37.8756 29.6476 38.0588Z",
    fill: "url(#paint240_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.6476 36.3185C29.6476 36.5017 29.5109 36.639 29.3287 36.639C29.1464 36.639 29.0098 36.5017 29.0098 36.3185C29.0098 36.1354 29.1464 35.998 29.3287 35.998C29.4654 35.998 29.6476 36.1812 29.6476 36.3185Z",
    fill: "url(#paint241_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1535 51.6545C32.1535 51.8376 32.0168 51.9749 31.8346 51.9749C31.6523 51.9749 31.5156 51.8376 31.5156 51.6545C31.5156 51.4713 31.6523 51.334 31.8346 51.334C32.0168 51.334 32.1535 51.5171 32.1535 51.6545Z",
    fill: "url(#paint242_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 49.9614C32.1534 50.1445 32.0167 50.2818 31.8344 50.2818C31.6522 50.2818 31.5155 50.1445 31.5155 49.9614C31.5155 49.7782 31.6522 49.6409 31.8344 49.6409C32.0167 49.6409 32.1534 49.7782 32.1534 49.9614Z",
    fill: "url(#paint243_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 48.268C32.1534 48.4511 32.0167 48.5885 31.8344 48.5885C31.6522 48.5885 31.5155 48.4511 31.5155 48.268C31.5155 48.0849 31.6522 47.9475 31.8344 47.9475C32.0167 47.9475 32.1534 48.0849 32.1534 48.268Z",
    fill: "url(#paint244_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 46.5744C32.1534 46.7575 32.0167 46.8949 31.8344 46.8949C31.6522 46.8949 31.5155 46.7575 31.5155 46.5744C31.5155 46.3913 31.6522 46.2539 31.8344 46.2539C32.0167 46.2539 32.1534 46.3913 32.1534 46.5744Z",
    fill: "url(#paint245_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 44.8786C32.1534 45.0618 32.0167 45.1991 31.8344 45.1991C31.6522 45.1991 31.5155 45.0618 31.5155 44.8786C31.5155 44.6955 31.6522 44.5581 31.8344 44.5581C32.0167 44.5124 32.1534 44.6955 32.1534 44.8786Z",
    fill: "url(#paint246_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1534 43.143C32.1534 43.3261 32.0167 43.4635 31.8344 43.4635C31.6522 43.4635 31.5155 43.3261 31.5155 43.143C31.5155 42.9599 31.6522 42.8225 31.8344 42.8225C32.0167 42.8225 32.1534 42.9599 32.1534 43.143Z",
    fill: "url(#paint247_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1535 41.4455C32.1535 41.6286 32.0168 41.766 31.8346 41.766C31.6523 41.766 31.5156 41.6286 31.5156 41.4455C31.5156 41.2623 31.6523 41.125 31.8346 41.125C32.0168 41.125 32.1535 41.2623 32.1535 41.4455Z",
    fill: "url(#paint248_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1535 39.7521C32.1535 39.9352 32.0168 40.0726 31.8346 40.0726C31.6523 40.0726 31.5156 39.9352 31.5156 39.7521C31.5156 39.569 31.6523 39.4316 31.8346 39.4316C32.0168 39.4316 32.1535 39.569 32.1535 39.7521Z",
    fill: "url(#paint249_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M31.5156 38.0588C31.5156 37.9214 31.6067 37.7841 31.7434 37.7383C31.8801 37.8756 32.0168 38.0588 32.1079 38.2419C32.0624 38.3335 31.9712 38.3792 31.8346 38.3792C31.6523 38.3792 31.5156 38.2419 31.5156 38.0588Z",
    fill: "url(#paint250_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.1079 53.2593C32.0168 53.3966 31.8801 53.5798 31.789 53.7171C31.6067 53.7171 31.5156 53.5798 31.5156 53.3967C31.5156 53.2135 31.6523 53.0762 31.8346 53.0762C31.9712 53.0762 32.0624 53.122 32.1079 53.2593Z",
    fill: "url(#paint251_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M33.7949 43.138C33.7949 43.0006 33.886 42.9091 33.9772 42.8633C34.0227 43.0922 34.0683 43.2753 34.1138 43.5042C33.9316 43.4585 33.7949 43.3211 33.7949 43.138Z",
    fill: "url(#paint252_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M34.1138 47.9473C34.0683 48.1762 34.0227 48.3593 33.9772 48.5882C33.8405 48.5424 33.7949 48.4051 33.7949 48.2677C33.7949 48.0846 33.9316 47.9473 34.1138 47.9473Z",
    fill: "url(#paint253_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M33.7949 44.881C33.7949 44.6979 33.9316 44.5605 34.1139 44.5605C34.1594 44.5605 34.205 44.5605 34.2505 44.6063C34.2505 44.7895 34.2961 44.9726 34.2961 45.1557C34.2505 45.2015 34.205 45.2015 34.1139 45.2015C33.9316 45.2015 33.7949 45.0184 33.7949 44.881Z",
    fill: "url(#paint254_linear_2_694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M34.2961 46.2997C34.2961 46.4828 34.2961 46.6659 34.2505 46.8491C34.205 46.8491 34.1594 46.8949 34.1139 46.8949C33.9316 46.8949 33.7949 46.7575 33.7949 46.5744C33.7949 46.3913 33.9316 46.2539 34.1139 46.2539C34.1594 46.2539 34.2505 46.2539 34.2961 46.2997Z",
    fill: "url(#paint255_linear_2_694)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1225 57.3338C43.5587 57.3338 43.1016 56.8768 43.1016 56.3128V51.2573C43.1016 50.6935 43.5587 50.2363 44.1225 50.2363C44.6864 50.2363 45.1435 50.6935 45.1435 51.2573V56.3128C45.1435 56.8766 44.6864 57.3338 44.1225 57.3338Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1518 57.3338C32.588 57.3338 32.1309 56.8768 32.1309 56.3128V51.2573C32.1309 50.6935 32.588 50.2363 33.1518 50.2363C33.7157 50.2363 34.1728 50.6935 34.1728 51.2573V56.3128C34.1728 56.8766 33.7157 57.3338 33.1518 57.3338Z",
    fill: "#C0C0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9772 69.6974H35.3814C32.4601 69.6974 30.0918 67.3291 30.0918 64.4077V57.5842C30.0918 56.8841 30.6593 56.3164 31.3596 56.3164H45.9989C46.6991 56.3164 47.2667 56.8841 47.2667 57.5842V64.4077C47.2669 67.3291 44.8986 69.6974 41.9772 69.6974Z",
    fill: "#43A7D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9067 23.2287C61.9067 10.3486 51.4235 -0.0829509 38.5241 0.000497194C25.7741 0.0832646 15.5144 10.3579 15.4496 23.1081C15.4098 30.9505 19.2569 37.8959 25.1759 42.1309C27.5729 43.846 28.9774 46.6272 28.9774 49.5745V49.5749C28.9774 50.4191 29.6617 51.1033 30.5057 51.1033H46.8504C47.6945 51.1033 48.3787 50.4189 48.3787 49.5749V49.5749C48.3787 46.6153 49.8037 43.8367 52.2082 42.111C58.0809 37.8957 61.9067 31.0094 61.9067 23.2287Z",
    fill: "url(#paint256_linear_2_694)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1551 51.1021C33.7461 45.0484 32.8359 35.4539 32.8359 24.6533C32.8359 15.114 33.546 6.51553 34.6825 0.466568C34.6825 0.466568 37.2166 -0.282831 42.6526 0.337789C43.8041 6.39302 44.5245 15.0462 44.5245 24.6528C44.5245 35.4545 43.6131 45.0484 42.2047 51.1023L35.1551 51.1021Z",
    fill: "url(#paint257_linear_2_694)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.352 31.428C66.352 31.4265 66.3522 31.4252 66.3522 31.4237C66.3522 28.7562 64.1897 26.5938 61.5223 26.5938C58.8548 26.5938 56.6924 28.7562 56.6924 31.4237C56.6924 31.4252 56.6925 31.4265 56.6925 31.428C54.2582 31.519 52.2949 33.537 52.2949 35.9923V35.9923C52.2949 38.5052 54.3509 40.5612 56.8636 40.5612H66.1808C68.6936 40.5612 70.7496 38.5052 70.7496 35.9923V35.9923C70.7496 33.537 68.7862 31.519 66.352 31.428Z",
    fill: "#52CBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8852 14.9534C17.8852 14.9519 17.8854 14.9506 17.8854 14.9491C17.8854 12.2816 15.723 10.1191 13.0555 10.1191C10.388 10.1191 8.22555 12.2816 8.22555 14.9491C8.22555 14.9506 8.22569 14.9519 8.22569 14.9534C5.7914 15.0443 3.82812 17.0623 3.82812 19.5177V19.5177C3.82812 22.0306 5.88411 24.0864 8.39694 24.0864H17.7141C20.227 24.0864 22.2829 22.0304 22.2829 19.5177V19.5177C22.2828 17.0623 20.3194 15.0443 17.8852 14.9534Z",
    fill: "#52CBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_694",
    x1: 18.9565,
    y1: 33.2531,
    x2: 19.5332,
    y2: 33.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_694",
    x1: 21.4174,
    y1: 33.1554,
    x2: 22.0652,
    y2: 33.1554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_694",
    x1: 23.9493,
    y1: 33.2472,
    x2: 24.5379,
    y2: 33.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_694",
    x1: 16.3719,
    y1: 34.6335,
    x2: 17.0196,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_694",
    x1: 18.8979,
    y1: 34.6335,
    x2: 19.5418,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_694",
    x1: 21.4174,
    y1: 34.6335,
    x2: 22.0652,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_694",
    x1: 23.9414,
    y1: 34.6335,
    x2: 24.5853,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_694",
    x1: 26.4615,
    y1: 34.6335,
    x2: 27.1093,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_694",
    x1: 13.8544,
    y1: 36.3376,
    x2: 14.4982,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_694",
    x1: 16.3719,
    y1: 36.3376,
    x2: 17.0196,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_694",
    x1: 18.8979,
    y1: 36.3376,
    x2: 19.5418,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_694",
    x1: 21.4161,
    y1: 36.3376,
    x2: 22.0639,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_694",
    x1: 23.9414,
    y1: 36.3376,
    x2: 24.5853,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_694",
    x1: 26.4615,
    y1: 36.3376,
    x2: 27.1093,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_694",
    x1: 28.9849,
    y1: 36.3376,
    x2: 29.6288,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_694",
    x1: 11.4159,
    y1: 38.06,
    x2: 11.9768,
    y2: 38.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_694",
    x1: 13.8544,
    y1: 38.0409,
    x2: 14.4982,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_694",
    x1: 16.3719,
    y1: 38.0409,
    x2: 17.0196,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_694",
    x1: 18.8979,
    y1: 38.0409,
    x2: 19.5418,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_694",
    x1: 21.4161,
    y1: 38.0409,
    x2: 22.0639,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_694",
    x1: 23.9414,
    y1: 38.0409,
    x2: 24.5853,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_694",
    x1: 26.4615,
    y1: 38.0409,
    x2: 27.1093,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_694",
    x1: 28.9849,
    y1: 38.0409,
    x2: 29.6288,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_694",
    x1: 31.5051,
    y1: 38.0478,
    x2: 32.1015,
    y2: 38.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_694",
    x1: 11.3284,
    y1: 39.7452,
    x2: 11.9762,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_694",
    x1: 13.8544,
    y1: 39.7452,
    x2: 14.4982,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_694",
    x1: 16.3719,
    y1: 39.7452,
    x2: 17.0196,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_694",
    x1: 18.8979,
    y1: 39.7452,
    x2: 19.5418,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_694",
    x1: 21.4174,
    y1: 39.7452,
    x2: 22.0652,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_694",
    x1: 23.9414,
    y1: 39.7452,
    x2: 24.5853,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_694",
    x1: 26.4615,
    y1: 39.7452,
    x2: 27.1093,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_694",
    x1: 28.9849,
    y1: 39.7452,
    x2: 29.6288,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_694",
    x1: 31.5051,
    y1: 39.7452,
    x2: 32.1528,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2_694",
    x1: 11.3284,
    y1: 41.4493,
    x2: 11.9762,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2_694",
    x1: 13.8544,
    y1: 41.4493,
    x2: 14.4982,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2_694",
    x1: 16.3719,
    y1: 41.4493,
    x2: 17.0196,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2_694",
    x1: 18.8979,
    y1: 41.4493,
    x2: 19.5418,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2_694",
    x1: 21.4174,
    y1: 41.4493,
    x2: 22.0652,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2_694",
    x1: 23.9414,
    y1: 41.4493,
    x2: 24.5853,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2_694",
    x1: 26.4615,
    y1: 41.4493,
    x2: 27.1093,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2_694",
    x1: 28.9849,
    y1: 41.4493,
    x2: 29.6288,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2_694",
    x1: 31.5051,
    y1: 41.4493,
    x2: 32.1528,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2_694",
    x1: 9.35778,
    y1: 43.1834,
    x2: 9.59088,
    y2: 43.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2_694",
    x1: 11.3284,
    y1: 43.1553,
    x2: 11.9762,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2_694",
    x1: 13.8544,
    y1: 43.1553,
    x2: 14.4982,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2_694",
    x1: 16.3719,
    y1: 43.1553,
    x2: 17.0196,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2_694",
    x1: 18.8979,
    y1: 43.1553,
    x2: 19.5418,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2_694",
    x1: 21.4161,
    y1: 43.1553,
    x2: 22.0639,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2_694",
    x1: 23.9414,
    y1: 43.1553,
    x2: 24.5853,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2_694",
    x1: 26.4617,
    y1: 43.1556,
    x2: 27.1094,
    y2: 43.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2_694",
    x1: 28.9849,
    y1: 43.1553,
    x2: 29.6288,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2_694",
    x1: 31.5049,
    y1: 43.1556,
    x2: 32.1527,
    y2: 43.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2_694",
    x1: 33.7821,
    y1: 43.1665,
    x2: 34.0903,
    y2: 43.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2_694",
    x1: 9.16881,
    y1: 44.8563,
    x2: 9.59148,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2_694",
    x1: 11.3284,
    y1: 44.8561,
    x2: 11.9762,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2_694",
    x1: 13.8544,
    y1: 44.8561,
    x2: 14.4982,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2_694",
    x1: 16.3719,
    y1: 44.8561,
    x2: 17.0196,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2_694",
    x1: 18.8979,
    y1: 44.8561,
    x2: 19.5418,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2_694",
    x1: 21.4174,
    y1: 44.8563,
    x2: 22.0652,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2_694",
    x1: 23.9414,
    y1: 44.8561,
    x2: 24.5853,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2_694",
    x1: 26.4617,
    y1: 44.8563,
    x2: 27.1094,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2_694",
    x1: 28.9849,
    y1: 44.8561,
    x2: 29.6288,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2_694",
    x1: 31.5049,
    y1: 44.8563,
    x2: 32.1527,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2_694",
    x1: 33.7815,
    y1: 44.8557,
    x2: 34.2752,
    y2: 44.8557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2_694",
    x1: 9.16881,
    y1: 46.5629,
    x2: 9.59148,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2_694",
    x1: 11.3284,
    y1: 46.5629,
    x2: 11.9762,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2_694",
    x1: 13.8544,
    y1: 46.5629,
    x2: 14.4982,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2_694",
    x1: 16.3719,
    y1: 46.5629,
    x2: 17.0196,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2_694",
    x1: 18.8979,
    y1: 46.5629,
    x2: 19.5418,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2_694",
    x1: 21.4161,
    y1: 46.5629,
    x2: 22.0639,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2_694",
    x1: 23.9414,
    y1: 46.5629,
    x2: 24.5853,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2_694",
    x1: 26.4617,
    y1: 46.5629,
    x2: 27.1094,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2_694",
    x1: 28.9849,
    y1: 46.5629,
    x2: 29.6288,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2_694",
    x1: 31.5049,
    y1: 46.5629,
    x2: 32.1527,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2_694",
    x1: 33.7815,
    y1: 46.5629,
    x2: 34.2792,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2_694",
    x1: 9.34266,
    y1: 48.2404,
    x2: 9.59151,
    y2: 48.2404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2_694",
    x1: 11.3284,
    y1: 48.2671,
    x2: 11.9762,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2_694",
    x1: 13.8544,
    y1: 48.2671,
    x2: 14.4982,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2_694",
    x1: 16.3719,
    y1: 48.2671,
    x2: 17.0196,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2_694",
    x1: 18.8979,
    y1: 48.2671,
    x2: 19.5418,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2_694",
    x1: 21.4174,
    y1: 48.2673,
    x2: 22.0652,
    y2: 48.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2_694",
    x1: 23.9414,
    y1: 48.2671,
    x2: 24.5853,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2_694",
    x1: 26.4617,
    y1: 48.2673,
    x2: 27.1094,
    y2: 48.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2_694",
    x1: 28.9849,
    y1: 48.2671,
    x2: 29.6288,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2_694",
    x1: 31.5049,
    y1: 48.2673,
    x2: 32.1527,
    y2: 48.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2_694",
    x1: 33.7815,
    y1: 48.2552,
    x2: 34.1015,
    y2: 48.2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2_694",
    x1: 11.3284,
    y1: 49.9693,
    x2: 11.9762,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2_694",
    x1: 13.8544,
    y1: 49.9693,
    x2: 14.4982,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2_694",
    x1: 16.3719,
    y1: 49.9693,
    x2: 17.0196,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2_694",
    x1: 18.8979,
    y1: 49.9693,
    x2: 19.5418,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2_694",
    x1: 21.4174,
    y1: 49.9695,
    x2: 22.0652,
    y2: 49.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2_694",
    x1: 23.9414,
    y1: 49.9693,
    x2: 24.5853,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2_694",
    x1: 26.4617,
    y1: 49.9695,
    x2: 27.1094,
    y2: 49.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2_694",
    x1: 28.9849,
    y1: 49.9693,
    x2: 29.6288,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2_694",
    x1: 31.5049,
    y1: 49.9695,
    x2: 32.1527,
    y2: 49.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2_694",
    x1: 11.3284,
    y1: 51.6735,
    x2: 11.9762,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2_694",
    x1: 13.8544,
    y1: 51.6735,
    x2: 14.4982,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2_694",
    x1: 16.3719,
    y1: 51.6735,
    x2: 17.0196,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2_694",
    x1: 18.8979,
    y1: 51.6735,
    x2: 19.5418,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2_694",
    x1: 21.4174,
    y1: 51.6735,
    x2: 22.0652,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2_694",
    x1: 23.9414,
    y1: 51.6735,
    x2: 24.5853,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2_694",
    x1: 26.4615,
    y1: 51.6735,
    x2: 27.1093,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2_694",
    x1: 28.9849,
    y1: 51.6735,
    x2: 29.6288,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2_694",
    x1: 31.5051,
    y1: 51.6735,
    x2: 32.1528,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2_694",
    x1: 11.3889,
    y1: 53.3707,
    x2: 11.9775,
    y2: 53.3707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2_694",
    x1: 13.8544,
    y1: 53.3806,
    x2: 14.4982,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2_694",
    x1: 16.3719,
    y1: 53.3806,
    x2: 17.0196,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2_694",
    x1: 18.8979,
    y1: 53.3806,
    x2: 19.5418,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2_694",
    x1: 21.4174,
    y1: 53.3806,
    x2: 22.0652,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2_694",
    x1: 23.9414,
    y1: 53.3806,
    x2: 24.5853,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2_694",
    x1: 26.4615,
    y1: 53.3806,
    x2: 27.1093,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2_694",
    x1: 28.9849,
    y1: 53.3806,
    x2: 29.6288,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2_694",
    x1: 31.5051,
    y1: 53.3787,
    x2: 32.1291,
    y2: 53.3787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2_694",
    x1: 13.8544,
    y1: 55.0829,
    x2: 14.4982,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2_694",
    x1: 16.3719,
    y1: 55.0829,
    x2: 17.0196,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2_694",
    x1: 18.8979,
    y1: 55.0829,
    x2: 19.5418,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2_694",
    x1: 21.4174,
    y1: 55.0829,
    x2: 22.0652,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2_694",
    x1: 23.9414,
    y1: 55.0829,
    x2: 24.5853,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2_694",
    x1: 26.4615,
    y1: 55.0829,
    x2: 27.1093,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2_694",
    x1: 28.9849,
    y1: 55.0829,
    x2: 29.6288,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2_694",
    x1: 16.3719,
    y1: 56.787,
    x2: 17.0196,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2_694",
    x1: 18.8979,
    y1: 56.787,
    x2: 19.5418,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2_694",
    x1: 21.4161,
    y1: 56.787,
    x2: 22.0639,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2_694",
    x1: 23.9414,
    y1: 56.787,
    x2: 24.5853,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2_694",
    x1: 26.4615,
    y1: 56.787,
    x2: 27.1093,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2_694",
    x1: 18.9967,
    y1: 58.2682,
    x2: 19.5181,
    y2: 58.2682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2_694",
    x1: 21.4174,
    y1: 58.3682,
    x2: 22.0652,
    y2: 58.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2_694",
    x1: 23.9612,
    y1: 58.2729,
    x2: 24.4984,
    y2: 58.2729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2_694",
    x1: 9.16881,
    y1: 46.5629,
    x2: 9.59148,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2_694",
    x1: 9.16881,
    y1: 44.8563,
    x2: 9.59148,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2_694",
    x1: 9.34266,
    y1: 48.2404,
    x2: 9.59151,
    y2: 48.2404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2_694",
    x1: 9.35778,
    y1: 43.1834,
    x2: 9.59088,
    y2: 43.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2_694",
    x1: 11.3284,
    y1: 51.6735,
    x2: 11.9762,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2_694",
    x1: 11.3284,
    y1: 49.9693,
    x2: 11.9762,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2_694",
    x1: 11.3284,
    y1: 48.2671,
    x2: 11.9762,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2_694",
    x1: 11.3284,
    y1: 46.5629,
    x2: 11.9762,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2_694",
    x1: 11.3284,
    y1: 44.8561,
    x2: 11.9762,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2_694",
    x1: 11.3284,
    y1: 43.1553,
    x2: 11.9762,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2_694",
    x1: 11.3284,
    y1: 41.4493,
    x2: 11.9762,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2_694",
    x1: 11.3284,
    y1: 39.7452,
    x2: 11.9762,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2_694",
    x1: 11.3889,
    y1: 53.3707,
    x2: 11.9775,
    y2: 53.3707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2_694",
    x1: 11.4159,
    y1: 38.06,
    x2: 11.9768,
    y2: 38.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2_694",
    x1: 13.8544,
    y1: 55.0829,
    x2: 14.4982,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2_694",
    x1: 13.8544,
    y1: 53.3806,
    x2: 14.4982,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2_694",
    x1: 13.8544,
    y1: 51.6735,
    x2: 14.4982,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2_694",
    x1: 13.8544,
    y1: 49.9693,
    x2: 14.4982,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2_694",
    x1: 13.8544,
    y1: 48.2671,
    x2: 14.4982,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2_694",
    x1: 13.8544,
    y1: 46.5629,
    x2: 14.4982,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2_694",
    x1: 13.8544,
    y1: 44.8561,
    x2: 14.4982,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2_694",
    x1: 13.8544,
    y1: 43.1553,
    x2: 14.4982,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2_694",
    x1: 13.8544,
    y1: 41.4493,
    x2: 14.4982,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2_694",
    x1: 13.8544,
    y1: 39.7452,
    x2: 14.4982,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2_694",
    x1: 13.8544,
    y1: 38.0409,
    x2: 14.4982,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2_694",
    x1: 13.8544,
    y1: 36.3376,
    x2: 14.4982,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2_694",
    x1: 16.3719,
    y1: 56.787,
    x2: 17.0196,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2_694",
    x1: 16.3719,
    y1: 55.0829,
    x2: 17.0196,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2_694",
    x1: 16.3719,
    y1: 53.3806,
    x2: 17.0196,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2_694",
    x1: 16.3719,
    y1: 51.6735,
    x2: 17.0196,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2_694",
    x1: 16.3719,
    y1: 49.9693,
    x2: 17.0196,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2_694",
    x1: 16.3719,
    y1: 48.2671,
    x2: 17.0196,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2_694",
    x1: 16.3719,
    y1: 46.5629,
    x2: 17.0196,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2_694",
    x1: 16.3719,
    y1: 44.8561,
    x2: 17.0196,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2_694",
    x1: 16.3719,
    y1: 43.1553,
    x2: 17.0196,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2_694",
    x1: 16.3719,
    y1: 41.4493,
    x2: 17.0196,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2_694",
    x1: 16.3719,
    y1: 39.7452,
    x2: 17.0196,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2_694",
    x1: 16.3719,
    y1: 38.0409,
    x2: 17.0196,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2_694",
    x1: 16.3719,
    y1: 36.3376,
    x2: 17.0196,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2_694",
    x1: 16.3719,
    y1: 34.6335,
    x2: 17.0196,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2_694",
    x1: 18.9565,
    y1: 33.2531,
    x2: 19.5332,
    y2: 33.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2_694",
    x1: 18.8979,
    y1: 56.787,
    x2: 19.5418,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2_694",
    x1: 18.8979,
    y1: 55.0829,
    x2: 19.5418,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2_694",
    x1: 18.8979,
    y1: 53.3806,
    x2: 19.5418,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2_694",
    x1: 18.8979,
    y1: 51.6735,
    x2: 19.5418,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2_694",
    x1: 18.8979,
    y1: 49.9693,
    x2: 19.5418,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2_694",
    x1: 18.8979,
    y1: 48.2671,
    x2: 19.5418,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2_694",
    x1: 18.8979,
    y1: 46.5629,
    x2: 19.5418,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2_694",
    x1: 18.8979,
    y1: 44.8561,
    x2: 19.5418,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2_694",
    x1: 18.8979,
    y1: 43.1553,
    x2: 19.5418,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2_694",
    x1: 18.8979,
    y1: 41.4493,
    x2: 19.5418,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2_694",
    x1: 18.8979,
    y1: 39.7452,
    x2: 19.5418,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2_694",
    x1: 18.8979,
    y1: 38.0409,
    x2: 19.5418,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2_694",
    x1: 18.8979,
    y1: 36.3376,
    x2: 19.5418,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2_694",
    x1: 18.8979,
    y1: 34.6335,
    x2: 19.5418,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2_694",
    x1: 18.9967,
    y1: 58.2682,
    x2: 19.5181,
    y2: 58.2682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2_694",
    x1: 21.4161,
    y1: 56.787,
    x2: 22.0639,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2_694",
    x1: 21.4174,
    y1: 55.0829,
    x2: 22.0652,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2_694",
    x1: 21.4174,
    y1: 53.3806,
    x2: 22.0652,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2_694",
    x1: 21.4174,
    y1: 51.6735,
    x2: 22.0652,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2_694",
    x1: 21.4174,
    y1: 49.9695,
    x2: 22.0652,
    y2: 49.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2_694",
    x1: 21.4174,
    y1: 48.2673,
    x2: 22.0652,
    y2: 48.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2_694",
    x1: 21.4161,
    y1: 46.5629,
    x2: 22.0639,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2_694",
    x1: 21.4174,
    y1: 44.8563,
    x2: 22.0652,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2_694",
    x1: 21.4161,
    y1: 43.1553,
    x2: 22.0639,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2_694",
    x1: 21.4174,
    y1: 41.4493,
    x2: 22.0652,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2_694",
    x1: 21.4174,
    y1: 39.7452,
    x2: 22.0652,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2_694",
    x1: 21.4161,
    y1: 38.0409,
    x2: 22.0639,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2_694",
    x1: 21.4161,
    y1: 36.3376,
    x2: 22.0639,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2_694",
    x1: 21.4174,
    y1: 34.6335,
    x2: 22.0652,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2_694",
    x1: 21.4174,
    y1: 33.1554,
    x2: 22.0652,
    y2: 33.1554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2_694",
    x1: 21.4174,
    y1: 58.3682,
    x2: 22.0652,
    y2: 58.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2_694",
    x1: 23.9414,
    y1: 56.787,
    x2: 24.5853,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2_694",
    x1: 23.9414,
    y1: 55.0829,
    x2: 24.5853,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2_694",
    x1: 23.9414,
    y1: 53.3806,
    x2: 24.5853,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2_694",
    x1: 23.9414,
    y1: 51.6735,
    x2: 24.5853,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2_694",
    x1: 23.9414,
    y1: 49.9693,
    x2: 24.5853,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2_694",
    x1: 23.9414,
    y1: 48.2671,
    x2: 24.5853,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2_694",
    x1: 23.9414,
    y1: 46.5629,
    x2: 24.5853,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2_694",
    x1: 23.9414,
    y1: 44.8561,
    x2: 24.5853,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2_694",
    x1: 23.9414,
    y1: 43.1553,
    x2: 24.5853,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2_694",
    x1: 23.9414,
    y1: 41.4493,
    x2: 24.5853,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2_694",
    x1: 23.9414,
    y1: 39.7452,
    x2: 24.5853,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2_694",
    x1: 23.9414,
    y1: 38.0409,
    x2: 24.5853,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2_694",
    x1: 23.9414,
    y1: 36.3376,
    x2: 24.5853,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2_694",
    x1: 23.9414,
    y1: 34.6335,
    x2: 24.5853,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2_694",
    x1: 23.9612,
    y1: 58.2729,
    x2: 24.4984,
    y2: 58.2729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2_694",
    x1: 23.9493,
    y1: 33.2472,
    x2: 24.5379,
    y2: 33.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2_694",
    x1: 26.4615,
    y1: 56.787,
    x2: 27.1093,
    y2: 56.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2_694",
    x1: 26.4615,
    y1: 55.0829,
    x2: 27.1093,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2_694",
    x1: 26.4615,
    y1: 53.3806,
    x2: 27.1093,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2_694",
    x1: 26.4615,
    y1: 51.6735,
    x2: 27.1093,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2_694",
    x1: 26.4617,
    y1: 49.9695,
    x2: 27.1094,
    y2: 49.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2_694",
    x1: 26.4617,
    y1: 48.2673,
    x2: 27.1094,
    y2: 48.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2_694",
    x1: 26.4617,
    y1: 46.5629,
    x2: 27.1094,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2_694",
    x1: 26.4617,
    y1: 44.8563,
    x2: 27.1094,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2_694",
    x1: 26.4617,
    y1: 43.1556,
    x2: 27.1094,
    y2: 43.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2_694",
    x1: 26.4615,
    y1: 41.4493,
    x2: 27.1093,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2_694",
    x1: 26.4615,
    y1: 39.7452,
    x2: 27.1093,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2_694",
    x1: 26.4615,
    y1: 38.0409,
    x2: 27.1093,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2_694",
    x1: 26.4615,
    y1: 36.3376,
    x2: 27.1093,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2_694",
    x1: 26.4615,
    y1: 34.6335,
    x2: 27.1093,
    y2: 34.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2_694",
    x1: 28.9849,
    y1: 55.0829,
    x2: 29.6288,
    y2: 55.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2_694",
    x1: 28.9849,
    y1: 53.3806,
    x2: 29.6288,
    y2: 53.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2_694",
    x1: 28.9849,
    y1: 51.6735,
    x2: 29.6288,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2_694",
    x1: 28.9849,
    y1: 49.9693,
    x2: 29.6288,
    y2: 49.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2_694",
    x1: 28.9849,
    y1: 48.2671,
    x2: 29.6288,
    y2: 48.2671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2_694",
    x1: 28.9849,
    y1: 46.5629,
    x2: 29.6288,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2_694",
    x1: 28.9849,
    y1: 44.8561,
    x2: 29.6288,
    y2: 44.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2_694",
    x1: 28.9849,
    y1: 43.1553,
    x2: 29.6288,
    y2: 43.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2_694",
    x1: 28.9849,
    y1: 41.4493,
    x2: 29.6288,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2_694",
    x1: 28.9849,
    y1: 39.7452,
    x2: 29.6288,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2_694",
    x1: 28.9849,
    y1: 38.0409,
    x2: 29.6288,
    y2: 38.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2_694",
    x1: 28.9849,
    y1: 36.3376,
    x2: 29.6288,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2_694",
    x1: 31.5051,
    y1: 51.6735,
    x2: 32.1528,
    y2: 51.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2_694",
    x1: 31.5049,
    y1: 49.9695,
    x2: 32.1527,
    y2: 49.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2_694",
    x1: 31.5049,
    y1: 48.2673,
    x2: 32.1527,
    y2: 48.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2_694",
    x1: 31.5049,
    y1: 46.5629,
    x2: 32.1527,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2_694",
    x1: 31.5049,
    y1: 44.8563,
    x2: 32.1527,
    y2: 44.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2_694",
    x1: 31.5049,
    y1: 43.1556,
    x2: 32.1527,
    y2: 43.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2_694",
    x1: 31.5051,
    y1: 41.4493,
    x2: 32.1528,
    y2: 41.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2_694",
    x1: 31.5051,
    y1: 39.7452,
    x2: 32.1528,
    y2: 39.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2_694",
    x1: 31.5051,
    y1: 38.0489,
    x2: 32.1015,
    y2: 38.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2_694",
    x1: 31.5051,
    y1: 53.3787,
    x2: 32.1291,
    y2: 53.3787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2_694",
    x1: 33.7815,
    y1: 43.1665,
    x2: 34.0896,
    y2: 43.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2_694",
    x1: 33.7815,
    y1: 48.2552,
    x2: 34.1015,
    y2: 48.2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2_694",
    x1: 33.7815,
    y1: 44.8587,
    x2: 34.2752,
    y2: 44.8587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2_694",
    x1: 33.7815,
    y1: 46.5629,
    x2: 34.2792,
    y2: 46.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2_694",
    x1: 39.5395,
    y1: 79.1121,
    x2: 13.1815,
    y2: -4.77365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2_694",
    x1: 38.0429,
    y1: -19.4072,
    x2: 43.3513,
    y2: -12.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceicon1);
export default __webpack_public_path__ + "static/media/priceicon1.7349469d06a8ac1709c71f9ba7bf9f9a.svg";
export { ForwardRef as ReactComponent };